import React, { useEffect, useMemo, useState } from "react";
import {
    buildNpWmsGoodsDryRun,
    buildNpWmsPlanDryRun,
    checkNpWmsConnection,
    copyInboundInvoice,
    createInvoiceLine,
    createInboundInvoice,
    createFulfillmentWarehouseEntity,
    createSupplierLegalEntity,
    createSupplierParserProfile,
    createWholesaleSupplier,
    createWholesaleContentSource,
    importSnimportWholesaleContent,
    createFulfillmentWholesaleRoute,
    deleteFulfillmentWarehouseEntity,
    deleteInboundInvoice,
    deleteInvoiceLine,
    listFulfillmentWarehouseEntities,
    updateFulfillmentWarehouseEntity,
    listFulfillmentSupplierConfigs,
    listFulfillmentWholesaleRoutes,
    listWholesaleContentSources,
    createFulfillmentSupplierConfig,
    updateFulfillmentSupplierConfig,
    deleteFulfillmentSupplierConfig,
    discoverNpApiFulfillmentRefs,
    getDropshipSenderStock,
    getDropshipSenderStockAnalogs,
    getFulfillmentRuntimeConfig,
    getInboundInvoice,
    getInvoiceStockAudit,
    listFulfillmentStockSnapshots,
    listInboundInvoices,
    listSupplierLegalEntities,
    listWholesaleSuppliers,
    parseInboundInvoice,
    syncInboundInvoiceIdentities,
    pollNpWmsFactInbound,
    searchDropshipSenderStockProducts,
    searchFulfillmentProducts,
    sendNpWmsGoodsAndPlan,
    simulateNpWmsFactPlaced,
    syncFulfillmentStockFromNpWms,
    updateInvoiceLine,
    updateFulfillmentProductDimensions,
    updateInboundInvoice,
    updateWholesaleSupplier,
    runWholesaleContentSource,
    updateFulfillmentWholesaleRoute,
    getFulfillmentSenderPricingProfile,
    upsertFulfillmentSenderPricingProfile,
    uploadInvoiceAttachment,
} from "../api/fulfillmentApi";
import {
    deleteCounterpartyWholesaleLink,
    listCounterparties,
    upsertCounterpartyWholesaleLink,
} from "../api/counterpartiesApi";
import { getBusinessOrganizations } from "../api/businessOrganizationsApi";
import {
    getOwnWarehouseInvoicePostingPreview,
    importOwnWarehouseSnimportInvoice,
    postOwnWarehouseInvoice,
    unpostOwnWarehouseInvoice,
} from "../api/ownWarehouseApi";
// Scoped design system (.suppliers-page .sp-*) — used by the redesigned
// «Поставщики опт» (wholesale) view, which wraps itself in .suppliers-page.
import "./SuppliersPage.css";

const pageStyle = { display: "grid", gap: "16px" };
const panelStyle = { background: "#fff", border: "1px solid #d9dee8", borderRadius: "8px", padding: "16px", boxShadow: "0 8px 22px rgba(15,23,42,.05)" };
const inputStyle = { width: "100%", border: "1px solid #cbd5e1", borderRadius: "8px", padding: "9px 10px", fontSize: "14px", boxSizing: "border-box" };
const labelStyle = { display: "grid", gap: "6px", fontSize: "13px", fontWeight: 700, color: "#111827" };
const buttonStyle = { border: "1px solid #cbd5e1", borderRadius: "8px", padding: "9px 12px", fontWeight: 800, cursor: "pointer", background: "#fff", color: "#111827" };
const primaryButtonStyle = { ...buttonStyle, borderColor: "#2563eb", background: "#2563eb", color: "#fff" };
const dangerButtonStyle = { ...buttonStyle, borderColor: "#fecaca", background: "#fef2f2", color: "#991b1b" };
const thStyle = { textAlign: "left", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", fontSize: "11px", color: "#475569", textTransform: "uppercase" };
const tdStyle = { padding: "8px 10px", borderBottom: "1px solid #eef2f7", fontSize: "13px", verticalAlign: "top" };
const mutedStyle = { margin: 0, color: "#64748b", fontSize: "13px" };
const errorStyle = { border: "1px solid #fca5a5", background: "#fef2f2", color: "#991b1b", borderRadius: "8px", padding: "10px 12px" };
const successStyle = { border: "1px solid #bbf7d0", background: "#f0fdf4", color: "#166534", borderRadius: "8px", padding: "10px 12px" };
const badgeBaseStyle = { display: "inline-flex", alignItems: "center", borderRadius: "999px", padding: "3px 9px", fontSize: "12px", fontWeight: 800, whiteSpace: "nowrap" };

const tabs = [
    { key: "wholesale", label: "Поставщики опт" },
    { key: "invoice_form", label: "Новая накладная" },
    { key: "invoice_registry", label: "Реестр накладных" },
    { key: "stock", label: "Fulfillment stock" },
    { key: "supplier_configs", label: "Реестр поставщиков" },
    { key: "wholesale_routes", label: "Оптовики фулфилмента" },
    { key: "sender_stock", label: "По отправителям" },
];
const npWarehouseOptions = [
    { value: "Boyarka", label: "N1 - Фулфілмент Київ (Boyarka)" },
    { value: "Lviv", label: "N2 - Фулфілмент Львів (Lviv)" },
    { value: "KyivSkhid", label: "N3 - Фулфілмент Київ (KyivSkhid)" },
    { value: "Od-FUL", label: "N4 - Фулфілмент Одеса (Od-FUL)" },
    { value: "Kv-FUL_5", label: "N5 - Фулфілмент Київ (Kv-FUL_5)" },
    { value: "Dnp-FUL", label: "N7 - Фулфілмент Дніпро (Dnp-FUL)" },
    { value: "Kv-FUL-9", label: "N9 - Фулфілмент Київ (Kv-FUL-9)" },
];

const todayIso = () => new Date().toISOString().slice(0, 10);
const Field = ({ label, children }) => <label style={labelStyle}><span>{label}</span>{children}</label>;
const routeEditFrom = (route) => ({
    is_active: Boolean(route.is_active),
    is_rrp: route.is_rrp == null ? "inherit" : String(Boolean(route.is_rrp)),
    priority_override: route.priority_override ?? "",
    min_markup_threshold: route.min_markup_threshold ?? "",
    dumping_mode: route.dumping_mode == null ? "inherit" : String(Boolean(route.dumping_mode)),
    extra_markup_enabled: route.extra_markup_enabled == null ? "inherit" : String(Boolean(route.extra_markup_enabled)),
    extra_markup_mode: route.extra_markup_mode || "percent",
    extra_markup_value: route.extra_markup_value ?? "",
    extra_markup_min: route.extra_markup_min ?? "",
    extra_markup_max: route.extra_markup_max ?? "",
});
const fulfillmentRoutePayload = (draft) => ({
    is_active: Boolean(draft.is_active),
    is_rrp: draft.is_rrp === "inherit" ? null : draft.is_rrp === "true",
    priority_override: draft.priority_override === "" ? null : Number(draft.priority_override),
    min_markup_threshold: draft.min_markup_threshold === "" ? null : Number(draft.min_markup_threshold),
    dumping_mode: draft.dumping_mode === "inherit" ? null : draft.dumping_mode === "true",
    extra_markup_enabled: draft.extra_markup_enabled === "inherit" ? null : draft.extra_markup_enabled === "true",
    extra_markup_mode: draft.extra_markup_value === "" ? null : (draft.extra_markup_mode || "percent"),
    extra_markup_value: draft.extra_markup_value === "" ? null : Number(draft.extra_markup_value),
    extra_markup_min: draft.extra_markup_min === "" ? null : Number(draft.extra_markup_min),
    extra_markup_max: draft.extra_markup_max === "" ? null : Number(draft.extra_markup_max),
});
const wmsFactBadgeStyle = (status) => {
    const normalized = String(status || "").trim().toLowerCase();
    if (!normalized) return { ...badgeBaseStyle, background: "#f1f5f9", color: "#64748b" };
    if (["размещена", "розміщена", "placed"].includes(normalized)) return { ...badgeBaseStyle, background: "#dcfce7", color: "#166534" };
    if (normalized === "принята") return { ...badgeBaseStyle, background: "#fef3c7", color: "#92400e" };
    if (["к выполнению", "в работе"].includes(normalized)) return { ...badgeBaseStyle, background: "#dbeafe", color: "#1d4ed8" };
    if (normalized === "отменена") return { ...badgeBaseStyle, background: "#fee2e2", color: "#991b1b" };
    return { ...badgeBaseStyle, background: "#f1f5f9", color: "#475569" };
};
const WmsFactBadge = ({ status }) => (
    <span style={wmsFactBadgeStyle(status)}>{status || "не получен"}</span>
);
const isWmsPlacedStatus = (status) => ["размещена", "розміщена", "placed"].includes(String(status || "").trim().toLowerCase());
const stockPillClassName = (value) => (Number(value || 0) > 0 ? "sp-pill g" : "sp-pill off");
const analogGroupDefinitions = [
    { key: "same_brand_line_dose", label: "Тот же бренд, линейка и дозировка" },
    { key: "same_dose", label: "Та же дозировка" },
    { key: "other", label: "Другие похожие товары" },
];
const qualityPillClassName = (quality) => {
    const normalized = String(quality || "").trim().toLowerCase();
    if (!normalized) return "sp-pill";
    return normalized.startsWith("кондиц") ? "sp-pill g" : "sp-pill warn";
};
const hasCompleteDimensions = (item) => Boolean(item?.dimensions_complete);
const dimensionBadge = (item) => {
    if (!item?.mapped_sku && !item?.sku) return "Нет SKU";
    if (item?.default_dimensions_used || item?.dimensions_source === "default") return "Дефолт";
    return hasCompleteDimensions(item) ? "ОК" : "Нет";
};
const dimensionText = (item) => {
    const weight = item?.weight_g ? `${item.weight_g} г` : "";
    const dims = [item?.length_mm, item?.width_mm, item?.height_mm].filter(Boolean).join(" x ");
    return [weight, dims ? `${dims} мм` : ""].filter(Boolean).join(" / ");
};
const productTitle = (item) => [item?.sku, item?.name_ua || item?.name_ru].filter(Boolean).join(" · ");
const apiErrorMessage = (err, fallback) => {
    const detail = err?.response?.data?.detail;
    if (typeof detail === "string" && detail) {
        return detail;
    }
    if (err?.message === "Network Error") {
        return "Network Error: backend API недоступен или вернул необработанную ошибку. Проверь, что API запущен на 127.0.0.1:8000 и перезапущен после изменений.";
    }
    return err?.message || fallback;
};
const isSnimportWholesaleSupplier = (supplier) => [
    supplier?.code,
    supplier?.name,
    supplier?.display_name,
    supplier?.dropship_supplier_code,
].some((value) => ["SNIMPORT", "BELOK"].includes(String(value || "").trim().toUpperCase()));

const DEFAULT_INVOICE_NP_WAREHOUSE = "Kv-FUL-48";
const isTsymkoOrganization = (organization) => [organization?.short_name, organization?.full_name, organization?.name]
    .some((value) => String(value || "").toLowerCase().includes("цимко"));
const createInitialInvoiceDraft = () => ({
    invoice_number: "",
    invoice_date: todayIso(),
    business_organization_id: "",
    delivery_via_np: true,
    expected_receipt_at: "",
    np_tracking_number: "",
    np_dest_warehouse: DEFAULT_INVOICE_NP_WAREHOUSE,
    wms_send_mode: "manual",
    wms_plan_source: "created_by_us",
    external_np_plan_ref: "",
    external_salesdrive_invoice_id: "",
    vat_included: false,
    default_vat_rate: "",
    retail_price_mode: "markup_percent",
    markup_percent: "",
});

// Режим own_warehouse (раздел «Склад»): реестр + форма накладных одного собственного склада,
// без NP/WMS-полей; вместо отправки в WMS — проведение накладной в остатки склада.
const defaultTabForMode = (mode) => (
    mode === "documents" || mode === "own_warehouse" ? "invoice_registry" : mode === "stocks" ? "stock" : "wholesale"
);

const FulfillmentPage = ({ embedded = false, mode = "full", ownWarehouseId = null, ownWarehouseCode = "", ownWarehouseOrganizationId = null }) => {
    const isOwnWarehouseMode = mode === "own_warehouse";
    const initialTab = defaultTabForMode(mode);
    const [activeTab, setActiveTab] = useState(initialTab);
    const [suppliers, setSuppliers] = useState([]);
    const [invoices, setInvoices] = useState([]);
    const [selectedSupplierId, setSelectedSupplierId] = useState("");
    const [wholesaleCreating, setWholesaleCreating] = useState(false);
    const [wholesaleDetailTab, setWholesaleDetailTab] = useState("details");
    const [showOnlyActiveSuppliers, setShowOnlyActiveSuppliers] = useState(false);
    const [selectedInvoiceId, setSelectedInvoiceId] = useState("");
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [detailOpen, setDetailOpen] = useState(false);
    const [registryFilters, setRegistryFilters] = useState({ dateFrom: "", dateTo: "", supplier: "", org: "", status: "", wmsStatus: "", search: "" });
    const [runtimeConfig, setRuntimeConfig] = useState({ debug_ui: false, d14_stock_source: "salesdrive_feed", np_wms_default_dest_warehouse: "" });
    const [legalEntities, setLegalEntities] = useState([]);
    const [businessOrganizations, setBusinessOrganizations] = useState([]);
    const [warehouseEntities, setWarehouseEntities] = useState([]);
    const [warehouseEntityDraft, setWarehouseEntityDraft] = useState({ warehouse: "", business_organization_id: "", is_active: true });
    const [supplierConfigs, setSupplierConfigs] = useState([]);
    const [fulfillmentRoutes, setFulfillmentRoutes] = useState([]);
    const [contentSources, setContentSources] = useState([]);
    const [contentImportResults, setContentImportResults] = useState({});
    const [contentDraft, setContentDraft] = useState({ name: "", source_type: "url", format_code: "auto", source_url: "" });
    const [snimportContentFile, setSnimportContentFile] = useState(null);
    const [snimportContentImporting, setSnimportContentImporting] = useState(false);
    const [snimportContentResult, setSnimportContentResult] = useState(null);
    const [routeDraft, setRouteDraft] = useState({
        fulfillment_sender_code: "", wholesale_supplier_id: "", is_active: true,
        is_rrp: "inherit", priority_override: "", min_markup_threshold: "", dumping_mode: "inherit",
        extra_markup_enabled: "inherit", extra_markup_mode: "percent", extra_markup_value: "",
        extra_markup_min: "", extra_markup_max: "",
    });
    const [routeEdits, setRouteEdits] = useState({});
    const [pricingProfileSender, setPricingProfileSender] = useState("");
    const [pricingProfileDraft, setPricingProfileDraft] = useState({ is_rrp: false, priority_override: "5", min_markup_threshold: "0", dumping_mode: false, extra_markup_enabled: false, extra_markup_value: "", extra_markup_min: "", extra_markup_max: "" });
    const [supplierConfigDraft, setSupplierConfigDraft] = useState({ supplier_code: "", business_organization_id: "", wms_managed: true, sellable_qualities: "", offer_source_mode: "legacy", is_active: true });
    const [counterparties, setCounterparties] = useState([]);
    const [selectedCounterpartyId, setSelectedCounterpartyId] = useState("");
    const [supplierDraft, setSupplierDraft] = useState({
        code: "MEDHOUSE",
        name: "ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ \"МЕДХАУС ТРЕЙД\"",
        display_name: "МЕДХАУС ТРЕЙД",
        dropship_supplier_code: "D14",
        default_parser_code: "medhouse_mmo",
        default_markup_percent: "",
        notes: "",
        is_active: true,
    });
    const [legalDraft, setLegalDraft] = useState({
        legal_name: "ТОВАРИСТВО З ОБМЕЖЕНОЮ ВІДПОВІДАЛЬНІСТЮ \"МЕДХАУС ТРЕЙД\"",
        short_name: "МЕДХАУС ТРЕЙД",
        tax_id: "",
        vat_payer: true,
        address: "",
        phone: "",
        email: "",
        is_default: true,
        is_active: true,
    });
    const [invoiceDraft, setInvoiceDraft] = useState(createInitialInvoiceDraft);
    const [files, setFiles] = useState([]);
    const [productSearch, setProductSearch] = useState("");
    const [productResults, setProductResults] = useState([]);
    const [manualLineDraft, setManualLineDraft] = useState({
        sku: "",
        supplier_product_code: "",
        supplier_product_name: "",
        barcode: "",
        manufacturer: "",
        qty_expected: "1",
        cost_price: "",
        vat_rate: "",
        line_total: "",
        retail_price_manual: "",
        expiration_date: "",
        batch_id: "",
        weight_g: "",
        length_mm: "",
        width_mm: "",
        height_mm: "",
    });
    const [lineDrafts, setLineDrafts] = useState({});
    const [editingLineIds, setEditingLineIds] = useState({});
    const [dimensionDrafts, setDimensionDrafts] = useState({});
    const [allowDefaultDimensions, setAllowDefaultDimensions] = useState(false);
    const [manualLineOpen, setManualLineOpen] = useState(false);
    const [npWmsCheck, setNpWmsCheck] = useState(null);
    const [npApiDiscovery, setNpApiDiscovery] = useState(null);
    const [stockAudit, setStockAudit] = useState(null);
    const [npWmsPlanDryRun, setNpWmsPlanDryRun] = useState(null);
    const [npWmsGoodsDryRun, setNpWmsGoodsDryRun] = useState(null);
    const [npWmsSendResult, setNpWmsSendResult] = useState(null);
    const [npWmsFactResult, setNpWmsFactResult] = useState(null);
    const [npWmsSending, setNpWmsSending] = useState(false);
    const [stockSnapshots, setStockSnapshots] = useState([]);
    const [stockFilters, setStockFilters] = useState({
        sku: "",
        warehouse: "",
        quality: "",
        business_organization_id: "",
        in_stock_only: true,
    });
    const [stockLoading, setStockLoading] = useState(false);
    const [stockSyncLoading, setStockSyncLoading] = useState(false);
    const [stockSyncResult, setStockSyncResult] = useState(null);
    const [senderStockQuery, setSenderStockQuery] = useState("");
    const [senderStockSearchRows, setSenderStockSearchRows] = useState([]);
    const [senderStockSelectedProduct, setSenderStockSelectedProduct] = useState(null);
    const [senderStockData, setSenderStockData] = useState(null);
    const [senderStockLoading, setSenderStockLoading] = useState(false);
    const [senderStockAnalogs, setSenderStockAnalogs] = useState(null);
    const [senderStockAnalogsLoading, setSenderStockAnalogsLoading] = useState(false);
    const [senderStockAnalogsInStockOnly, setSenderStockAnalogsInStockOnly] = useState(true);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    // Проведение накладной в собственный склад (только own_warehouse)
    const [postingPreview, setPostingPreview] = useState(null);
    const [postingReport, setPostingReport] = useState(null);
    const [postingBusy, setPostingBusy] = useState(false);
    const [snimportInvoiceFile, setSnimportInvoiceFile] = useState(null);
    const [snimportImporting, setSnimportImporting] = useState(false);

    const visibleTabs = useMemo(() => {
        if (mode === "documents" || mode === "own_warehouse") {
            return tabs.filter((tab) => ["invoice_registry", "invoice_form"].includes(tab.key));
        }
        if (mode === "stocks") {
            return tabs.filter((tab) => ["stock", "supplier_configs", "wholesale_routes", "sender_stock"].includes(tab.key));
        }
        if (mode === "wholesale") {
            return tabs.filter((tab) => tab.key === "wholesale");
        }
        return tabs;
    }, [mode]);
    const selectedSupplier = useMemo(
        () => suppliers.find((item) => String(item.id) === String(selectedSupplierId)),
        [suppliers, selectedSupplierId],
    );
    const selectedInvoiceSupplier = useMemo(
        () => suppliers.find((item) => String(item.id) === String(selectedInvoice?.supplier_id)),
        [suppliers, selectedInvoice],
    );
    const isRoslynaInvoice = selectedInvoiceSupplier?.code === "Рослина карпат";
    const isSnimportInvoice = isSnimportWholesaleSupplier(selectedInvoiceSupplier);
    const filteredSuppliers = useMemo(
        () => (showOnlyActiveSuppliers ? suppliers.filter((item) => item.is_active) : suppliers),
        [showOnlyActiveSuppliers, suppliers],
    );
    const linkedCounterparties = useMemo(
        () => counterparties
            .map((counterparty) => {
                const link = (counterparty.wholesale_links || []).find(
                    (item) => String(item.supplier_id) === String(selectedSupplierId),
                );
                return link ? { counterparty, link } : null;
            })
            .filter(Boolean),
        [counterparties, selectedSupplierId],
    );
    const unlinkedCounterparties = useMemo(
        () => counterparties.filter(
            (counterparty) => !(counterparty.wholesale_links || []).some(
                (item) => String(item.supplier_id) === String(selectedSupplierId),
            ),
        ),
        [counterparties, selectedSupplierId],
    );
    const debugUi = Boolean(runtimeConfig.debug_ui);

    const loadBase = async () => {
        setError("");
        try {
            const [supplierData, invoiceData, configData, counterpartyData, orgData, warehouseEntityData, supplierConfigData, routeData] = await Promise.all([
                listWholesaleSuppliers(),
                listInboundInvoices(isOwnWarehouseMode ? { warehouse_type: "own_warehouse", own_warehouse_id: ownWarehouseId } : undefined),
                getFulfillmentRuntimeConfig(),
                listCounterparties({ limit: 1000 }),
                getBusinessOrganizations({ limit: 1000 }).catch(() => []),
                listFulfillmentWarehouseEntities().catch(() => []),
                listFulfillmentSupplierConfigs().catch(() => []),
                listFulfillmentWholesaleRoutes().catch(() => []),
            ]);
            const nextRuntimeConfig = configData || { debug_ui: false, d14_stock_source: "salesdrive_feed", np_wms_default_dest_warehouse: "" };
            setRuntimeConfig(nextRuntimeConfig);
            const nextWarehouseEntities = Array.isArray(warehouseEntityData) ? warehouseEntityData : [];
            const nextBusinessOrganizations = Array.isArray(orgData) ? orgData : (orgData?.items || []);
            const defaultWarehouse = DEFAULT_INVOICE_NP_WAREHOUSE;
            setInvoiceDraft((prev) => {
                const warehouse = prev.np_dest_warehouse || defaultWarehouse;
                const mappedWarehouse = nextWarehouseEntities.find(
                    (item) => item.is_active && String(item.warehouse) === String(warehouse),
                );
                const tsymkoOrganization = nextBusinessOrganizations.find(isTsymkoOrganization);
                return {
                    ...prev,
                    np_dest_warehouse: warehouse,
                    // Цимко — начальный контур для новых накладных. Привязка
                    // склада остаётся запасным вариантом, если организация не найдена.
                    business_organization_id: prev.business_organization_id
                        || (tsymkoOrganization ? String(tsymkoOrganization.id) : "")
                        || (mappedWarehouse ? String(mappedWarehouse.business_organization_id) : ""),
                };
            });
            setSuppliers(supplierData);
            setInvoices(invoiceData);
            setCounterparties(Array.isArray(counterpartyData) ? counterpartyData : []);
            setBusinessOrganizations(nextBusinessOrganizations);
            setWarehouseEntities(Array.isArray(warehouseEntityData) ? warehouseEntityData : []);
            setSupplierConfigs(Array.isArray(supplierConfigData) ? supplierConfigData : []);
            const nextRoutes = Array.isArray(routeData) ? routeData : [];
            setFulfillmentRoutes(nextRoutes);
            setRouteEdits(Object.fromEntries(nextRoutes.map((route) => [route.id, routeEditFrom(route)])));
            if (!selectedSupplierId && supplierData.length) {
                const preferredSupplier = isOwnWarehouseMode
                    ? supplierData.find(isSnimportWholesaleSupplier)
                    : null;
                setSelectedSupplierId(String((preferredSupplier || supplierData[0]).id));
            }
            if (!selectedInvoiceId && invoiceData.length) setSelectedInvoiceId(String(invoiceData[0].id));
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки Fulfillment"));
        }
    };

    const loadSupplierDetails = async (supplierId) => {
        if (!supplierId) {
            setLegalEntities([]);
            return;
        }
        try {
            const [legal, sources] = await Promise.all([listSupplierLegalEntities(supplierId), listWholesaleContentSources(supplierId)]);
            setLegalEntities(legal);
            setContentSources(sources || []);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки юрлиц"));
        }
    };

    const loadInvoiceDetail = async (invoiceId) => {
        if (!invoiceId) {
            setSelectedInvoice(null);
            return;
        }
        try {
            const invoice = await getInboundInvoice(invoiceId);
            setSelectedInvoice(invoice);
            const editable = {};
            const dimensions = {};
            (invoice.lines || []).forEach((line) => {
                editable[line.id] = {
                    sku: line.mapped_sku || "",
                    supplier_product_code: line.supplier_product_code || "",
                    supplier_product_name: line.supplier_product_name || "",
                    barcode: line.barcode || "",
                    manufacturer: line.manufacturer || "",
                    qty_expected: line.qty_expected || "",
                    cost_price: line.cost_price || "",
                    vat_rate: line.vat_rate ?? "",
                    line_total: line.line_total || "",
                    retail_price_manual: line.retail_price_manual || "",
                    expiration_date: line.expiration_date || "",
                    batch_id: line.batch_id || "",
                };
                if (line.mapped_sku) {
                    dimensions[line.mapped_sku] = {
                        weight_g: line.weight_g || "",
                        length_mm: line.length_mm || "",
                        width_mm: line.width_mm || "",
                        height_mm: line.height_mm || "",
                    };
                }
            });
            setLineDrafts(editable);
            setDimensionDrafts(dimensions);
            setEditingLineIds({});
            setStockAudit(null);
            setNpWmsPlanDryRun(null);
            setNpWmsGoodsDryRun(null);
            setNpWmsSendResult(null);
            setNpWmsFactResult(null);
            setPostingPreview(null);
            setPostingReport(null);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки накладной"));
        }
    };

    useEffect(() => {
        setActiveTab(defaultTabForMode(mode));
    }, [mode]);

    useEffect(() => {
        // В режиме own_warehouse смена склада (?wh=) перезагружает реестр; в остальных
        // режимах ownWarehouseId всегда null — эффект срабатывает один раз, как раньше.
        if (isOwnWarehouseMode) {
            setSelectedInvoiceId("");
            setSelectedInvoice(null);
            setDetailOpen(false);
        }
        loadBase();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ownWarehouseId]);
    useEffect(() => { loadSupplierDetails(selectedSupplierId); }, [selectedSupplierId]);
    useEffect(() => {
        if (selectedSupplierId) {
            setRouteDraft((prev) => ({ ...prev, wholesale_supplier_id: String(selectedSupplierId) }));
        }
    }, [selectedSupplierId]);

    useEffect(() => {
        if (wholesaleCreating || !selectedSupplier) {
            return;
        }
        setSupplierDraft({
            code: selectedSupplier.code || "",
            name: selectedSupplier.name || "",
            display_name: selectedSupplier.display_name || "",
            dropship_supplier_code: selectedSupplier.dropship_supplier_code || "",
            default_parser_code: selectedSupplier.default_parser_code || "",
            default_markup_percent: selectedSupplier.default_markup_percent || "",
            notes: selectedSupplier.notes || "",
            is_active: Boolean(selectedSupplier.is_active),
        });
    }, [selectedSupplier, wholesaleCreating]);
    useEffect(() => { loadInvoiceDetail(selectedInvoiceId); }, [selectedInvoiceId]);
    useEffect(() => {
        if (activeTab === "stock") {
            loadStockSnapshots();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeTab]);

    const loadStockSnapshots = async () => {
        setError("");
        setStockLoading(true);
        try {
            const rows = await listFulfillmentStockSnapshots({
                sku: stockFilters.sku || undefined,
                warehouse: stockFilters.warehouse || undefined,
                quality: stockFilters.quality || undefined,
                business_organization_id: stockFilters.business_organization_id || undefined,
                in_stock_only: Boolean(stockFilters.in_stock_only),
                limit: 500,
            });
            setStockSnapshots(Array.isArray(rows) ? rows : []);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки fulfillment stock"));
        } finally {
            setStockLoading(false);
        }
    };

    const syncStockFromNpWms = async () => {
        setError("");
        setMessage("");
        setStockSyncLoading(true);
        try {
            const result = await syncFulfillmentStockFromNpWms({
                sku: stockFilters.sku || undefined,
                warehouse: stockFilters.warehouse || undefined,
                quality: stockFilters.quality || undefined,
                business_organization_id: stockFilters.business_organization_id || undefined,
                in_stock_only: false,
                limit: 500,
            });
            setStockSyncResult(result);
            setMessage(`NP WMS stock sync: ${result.status}, обновлено ${result.snapshots_updated || 0}, обнулено ${result.snapshots_zeroed || 0}`);
            await loadStockSnapshots();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка синхронизации stock из NP WMS"));
        } finally {
            setStockSyncLoading(false);
        }
    };

    const loadSenderStock = async (product) => {
        if (!product?.sku) return;
        setError("");
        setMessage("");
        setSenderStockSelectedProduct(product);
        setSenderStockLoading(true);
        try {
            const payload = await getDropshipSenderStock(product.sku);
            setSenderStockData(payload);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки остатков по отправителям"));
        } finally {
            setSenderStockLoading(false);
        }
    };

    const loadSenderStockAnalogs = async (inStockOnly = senderStockAnalogsInStockOnly) => {
        const product = senderStockData?.product || senderStockSelectedProduct;
        if (!product?.sku) return;
        setError("");
        setSenderStockAnalogsLoading(true);
        try {
            const payload = await getDropshipSenderStockAnalogs(product.sku, inStockOnly);
            setSenderStockAnalogs(payload);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки аналогов"));
        } finally {
            setSenderStockAnalogsLoading(false);
        }
    };

    const runSenderStockSearch = async () => {
        const query = senderStockQuery.trim();
        setSenderStockAnalogs(null);
        if (query.length < 2) {
            setSenderStockSearchRows([]);
            setSenderStockData(null);
            return;
        }
        setError("");
        setMessage("");
        setSenderStockLoading(true);
        try {
            const rows = await searchDropshipSenderStockProducts(query);
            setSenderStockSearchRows(Array.isArray(rows) ? rows : []);
            if (Array.isArray(rows) && rows.length === 1) {
                await loadSenderStock(rows[0]);
            }
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка поиска товара по отправителям"));
        } finally {
            setSenderStockLoading(false);
        }
    };

    const saveSupplier = async () => {
        setError("");
        setMessage("");
        try {
            const payload = {
                ...supplierDraft,
                default_markup_percent: supplierDraft.default_markup_percent || null,
            };
            if (wholesaleCreating || !selectedSupplierId) {
                const supplier = await createWholesaleSupplier(payload);
                if (payload.default_parser_code) {
                    await createSupplierParserProfile(supplier.id, { parser_code: payload.default_parser_code, file_type: "mmo", is_active: true });
                }
                setSelectedSupplierId(String(supplier.id));
                setWholesaleCreating(false);
                setMessage("Поставщик создан");
            } else {
                await updateWholesaleSupplier(selectedSupplierId, payload);
                setMessage("Поставщик сохранен");
            }
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка сохранения поставщика"));
        }
    };

    const createNewSupplier = () => {
        setWholesaleCreating(true);
        setSelectedSupplierId("");
        setWholesaleDetailTab("details");
        setSupplierDraft({
            code: "",
            name: "",
            display_name: "",
            dropship_supplier_code: "",
            default_parser_code: "",
            default_markup_percent: "",
            notes: "",
            is_active: true,
        });
        setSelectedCounterpartyId("");
        setError("");
        setMessage("");
    };

    const saveLegalEntity = async () => {
        if (!selectedSupplierId) return;
        setError("");
        setMessage("");
        try {
            await createSupplierLegalEntity(selectedSupplierId, legalDraft);
            setMessage("Юрлицо добавлено");
            await loadSupplierDetails(selectedSupplierId);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка создания юрлица"));
        }
    };

    const addCounterpartyLink = async () => {
        if (!selectedSupplierId || !selectedCounterpartyId) return;
        setError("");
        setMessage("");
        try {
            await upsertCounterpartyWholesaleLink(selectedCounterpartyId, {
                supplier_id: Number(selectedSupplierId),
                is_default: linkedCounterparties.length === 0,
                is_active: true,
                priority: linkedCounterparties.length === 0 ? 10 : 100,
            });
            setSelectedCounterpartyId("");
            setMessage("Контрагент связан с оптовым поставщиком");
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка связи контрагента"));
        }
    };

    const removeCounterpartyLink = async (counterpartyId, linkId) => {
        setError("");
        setMessage("");
        try {
            await deleteCounterpartyWholesaleLink(counterpartyId, linkId);
            setMessage("Связь с контрагентом удалена");
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка удаления связи контрагента"));
        }
    };

    const saveInvoice = async () => {
        if (!selectedSupplierId) return;
        setError("");
        setMessage("");
        if (!isOwnWarehouseMode && invoiceDraft.delivery_via_np && !invoiceDraft.np_tracking_number.trim()) {
            setError("Укажите номер экспресс-накладной Новой Почты");
            return;
        }
        if (!isOwnWarehouseMode && !invoiceDraft.delivery_via_np && !invoiceDraft.expected_receipt_at) {
            setError("Укажите дату и время ожидаемой поставки");
            return;
        }
        try {
            const defaultLegal = legalEntities.find((item) => item.is_default) || legalEntities[0];
            const ownWarehouseFields = isOwnWarehouseMode ? {
                warehouse_type: "own_warehouse",
                own_warehouse_id: Number(ownWarehouseId),
                business_organization_id: ownWarehouseOrganizationId ? Number(ownWarehouseOrganizationId) : null,
                delivery_via_np: false,
                expected_receipt_at: invoiceDraft.expected_receipt_at || null,
                np_tracking_number: null,
                np_dest_warehouse: null,
                wms_send_mode: "manual",
                wms_plan_source: "created_by_us",
                external_np_plan_ref: null,
                external_salesdrive_invoice_id: null,
            } : {};
            const invoice = await createInboundInvoice({
                supplier_id: Number(selectedSupplierId),
                legal_entity_id: defaultLegal?.id || null,
                business_organization_id: invoiceDraft.business_organization_id ? Number(invoiceDraft.business_organization_id) : null,
                invoice_number: invoiceDraft.invoice_number,
                invoice_date: invoiceDraft.invoice_date || null,
                delivery_via_np: Boolean(invoiceDraft.delivery_via_np),
                expected_receipt_at: invoiceDraft.delivery_via_np ? null : (invoiceDraft.expected_receipt_at || null),
                np_tracking_number: invoiceDraft.delivery_via_np ? (invoiceDraft.np_tracking_number || null) : null,
                np_dest_warehouse: invoiceDraft.np_dest_warehouse || null,
                wms_send_mode: invoiceDraft.wms_send_mode || "manual",
                wms_plan_source: invoiceDraft.wms_plan_source || "created_by_us",
                external_np_plan_ref: invoiceDraft.external_np_plan_ref || null,
                external_salesdrive_invoice_id: invoiceDraft.external_salesdrive_invoice_id || null,
                ...ownWarehouseFields,
                vat_included: Boolean(invoiceDraft.vat_included),
                default_vat_rate: invoiceDraft.vat_included ? (invoiceDraft.default_vat_rate || null) : null,
                retail_price_mode: invoiceDraft.retail_price_mode || "markup_percent",
                markup_percent: invoiceDraft.markup_percent || null,
                source_type: "manual",
                currency: "UAH",
            });
            setSelectedInvoiceId(String(invoice.id));
            setActiveTab("invoice_registry");
            setDetailOpen(true);
            setInvoiceDraft(createInitialInvoiceDraft());
            setMessage("Накладная создана");
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка создания накладной"));
        }
    };

    const refreshFulfillmentRoutes = async () => {
        const nextRoutes = await listFulfillmentWholesaleRoutes();
        setFulfillmentRoutes(nextRoutes);
        setRouteEdits(Object.fromEntries(nextRoutes.map((route) => [route.id, routeEditFrom(route)])));
    };

    const createWholesaleRoute = async () => {
        setError("");
        try {
            await createFulfillmentWholesaleRoute({
                wholesale_supplier_id: Number(routeDraft.wholesale_supplier_id),
                fulfillment_sender_code: routeDraft.fulfillment_sender_code,
                ...fulfillmentRoutePayload(routeDraft),
            });
            await refreshFulfillmentRoutes();
            setMessage("Маршрут и правила ценообразования добавлены");
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось добавить маршрут"));
        }
    };

    const saveWholesaleRoute = async (route) => {
        const draft = routeEdits[route.id] || routeEditFrom(route);
        setError("");
        try {
            await updateFulfillmentWholesaleRoute(route.id, fulfillmentRoutePayload(draft));
            await refreshFulfillmentRoutes();
            setMessage(`Правила ${route.wholesale_supplier_name} → ${route.fulfillment_sender_code} сохранены`);
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось сохранить правила маршрута"));
        }
    };

    const selectPricingProfileSender = async (senderCode) => {
        setPricingProfileSender(senderCode);
        setPricingProfileDraft({ is_rrp: false, priority_override: "5", min_markup_threshold: "0", dumping_mode: false, extra_markup_enabled: false, extra_markup_value: "", extra_markup_min: "", extra_markup_max: "" });
        if (!senderCode) return;
        try {
            const profile = await getFulfillmentSenderPricingProfile(senderCode);
            setPricingProfileDraft({
                is_rrp: Boolean(profile.is_rrp),
                priority_override: profile.priority ?? profile.priority_override ?? "5",
                min_markup_threshold: profile.min_markup_threshold ?? "0",
                dumping_mode: Boolean(profile.dumping_mode),
                extra_markup_enabled: Boolean(profile.extra_markup_enabled),
                extra_markup_value: profile.extra_markup_value ?? "",
                extra_markup_min: profile.extra_markup_min ?? "",
                extra_markup_max: profile.extra_markup_max ?? "",
            });
        } catch (err) {
            if (err?.response?.status !== 404) setError(apiErrorMessage(err, "Не удалось загрузить базовые правила sender"));
        }
    };

    const savePricingProfile = async () => {
        if (!pricingProfileSender) return;
        try {
            await upsertFulfillmentSenderPricingProfile(pricingProfileSender, {
                is_rrp: Boolean(pricingProfileDraft.is_rrp),
                priority_override: Number(pricingProfileDraft.priority_override || 0),
                min_markup_threshold: Number(pricingProfileDraft.min_markup_threshold || 0),
                dumping_mode: Boolean(pricingProfileDraft.dumping_mode),
                extra_markup_enabled: Boolean(pricingProfileDraft.extra_markup_enabled),
                extra_markup_mode: pricingProfileDraft.extra_markup_enabled ? "percent" : null,
                extra_markup_value: pricingProfileDraft.extra_markup_value === "" ? null : Number(pricingProfileDraft.extra_markup_value),
                extra_markup_min: pricingProfileDraft.extra_markup_min === "" ? null : Number(pricingProfileDraft.extra_markup_min),
                extra_markup_max: pricingProfileDraft.extra_markup_max === "" ? null : Number(pricingProfileDraft.extra_markup_max),
            });
            setMessage(`Базовые правила sender ${pricingProfileSender} сохранены`);
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось сохранить базовые правила sender"));
        }
    };

    const updateSelectedInvoice = async () => {
        if (!selectedInvoiceId || !selectedInvoice) return;
        setError("");
        setMessage("");
        if (!isOwnWarehouseMode && selectedInvoice.delivery_via_np == null) {
            setError("Выберите способ доставки: Новая Почта или другой перевозчик/самовывоз");
            return;
        }
        if (!isOwnWarehouseMode && selectedInvoice.delivery_via_np && !String(selectedInvoice.np_tracking_number || "").trim()) {
            setError("Укажите номер экспресс-накладной Новой Почты");
            return;
        }
        if (!isOwnWarehouseMode && !selectedInvoice.delivery_via_np && !selectedInvoice.expected_receipt_at) {
            setError("Укажите дату и время ожидаемой поставки");
            return;
        }
        try {
            await updateInboundInvoice(selectedInvoiceId, {
                ...(isOwnWarehouseMode ? { warehouse_type: "own_warehouse", own_warehouse_id: Number(ownWarehouseId) } : {}),
                invoice_number: selectedInvoice.invoice_number,
                invoice_date: selectedInvoice.invoice_date || null,
                business_organization_id: selectedInvoice.business_organization_id ? Number(selectedInvoice.business_organization_id) : null,
                delivery_via_np: selectedInvoice.delivery_via_np,
                expected_receipt_at: selectedInvoice.delivery_via_np ? null : (selectedInvoice.expected_receipt_at || null),
                np_tracking_number: selectedInvoice.delivery_via_np ? (selectedInvoice.np_tracking_number || null) : null,
                np_dest_warehouse: selectedInvoice.np_dest_warehouse || null,
                wms_send_mode: selectedInvoice.wms_send_mode || "manual",
                wms_plan_source: selectedInvoice.wms_plan_source || "created_by_us",
                external_np_plan_ref: selectedInvoice.external_np_plan_ref || null,
                external_salesdrive_invoice_id: selectedInvoice.external_salesdrive_invoice_id || null,
                status: selectedInvoice.status,
                vat_included: Boolean(selectedInvoice.vat_included),
                default_vat_rate: selectedInvoice.vat_included ? (selectedInvoice.default_vat_rate || null) : null,
                retail_price_mode: selectedInvoice.retail_price_mode || "markup_percent",
                markup_percent: selectedInvoice.markup_percent || null,
                ...(isOwnWarehouseMode ? {
                    delivery_via_np: false,
                    expected_receipt_at: selectedInvoice.expected_receipt_at || null,
                    np_tracking_number: null,
                    wms_send_mode: "manual",
                    wms_plan_source: "created_by_us",
                } : {}),
            });
            setMessage("Накладная обновлена");
            if (!isOwnWarehouseMode && (selectedInvoice.wms_send_mode || "manual") === "auto" && (selectedInvoice.wms_plan_source || "created_by_us") === "created_by_us") {
                const result = await sendNpWmsGoodsAndPlan(selectedInvoiceId);
                setNpWmsSendResult(result.plan || result.goods || result);
                setMessage(`Накладная обновлена, NP WMS goods + plan: ${result.status}`);
            }
            await loadBase();
            await loadInvoiceDetail(selectedInvoiceId);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка обновления накладной"));
        }
    };

    const copySelectedInvoice = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const copied = await copyInboundInvoice(selectedInvoiceId);
            setSelectedInvoiceId(String(copied.id));
            setMessage("Копия накладной создана");
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка копирования накладной"));
        }
    };

    const deleteSelectedInvoice = async () => {
        if (!selectedInvoiceId) return;
        if (!window.confirm("Удалить выбранную накладную?")) return;
        setError("");
        setMessage("");
        try {
            await deleteInboundInvoice(selectedInvoiceId);
            setSelectedInvoiceId("");
            setSelectedInvoice(null);
            setDetailOpen(false);
            setMessage("Накладная удалена");
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка удаления накладной"));
        }
    };

    const uploadFiles = async () => {
        if (!selectedInvoiceId || !files.length) return;
        setError("");
        setMessage("");
        try {
            for (const file of files) await uploadInvoiceAttachment(selectedInvoiceId, file);
            setFiles([]);
            setMessage("Файлы загружены");
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки файла"));
        }
    };

    const parseInvoice = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await parseInboundInvoice(selectedInvoiceId);
            const warnings = result.warnings?.length ? ` Warnings: ${result.warnings.join("; ")}` : "";
            setMessage(`Распознано строк: ${result.lines_created}.${warnings}`);
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка парсинга"));
        }
    };

    const syncInvoiceIdentities = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await syncInboundInvoiceIdentities(selectedInvoiceId);
            const summary = Object.entries(result.summary || {}).map(([key, value]) => `${key}: ${value}`).join(", ");
            setMessage(`Идентичности синхронизированы. ${summary || "Нет маппингов"}`);
            await loadInvoiceDetail(selectedInvoiceId);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка синхронизации идентичностей"));
        }
    };

    const uploadRoslynaOrderForm = async () => {
        const file = files.find((item) => /\.xlsx$/i.test(item.name || ""));
        if (!selectedInvoiceId || !file) {
            setError("Выберите Excel-бланк .xlsx для загрузки");
            return;
        }
        setError("");
        setMessage("");
        try {
            await uploadInvoiceAttachment(selectedInvoiceId, file);
            setFiles([]);
            const result = await parseInboundInvoice(selectedInvoiceId);
            const warnings = result.warnings?.length ? ` Предупреждения: ${result.warnings.join("; ")}` : "";
            setMessage(`Бланк залит: создано строк ${result.lines_created}.${warnings}`);
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось залить бланк Рослина карпат"));
        }
    };

    const uploadSnimportInvoice = async () => {
        const file = files.find((item) => /\.xls(x)?$/i.test(item.name || ""));
        if (!selectedInvoiceId || !file) {
            setError("Выберите накладную SNIMPORT в формате .xls или .xlsx");
            return;
        }
        setError("");
        setMessage("");
        try {
            await uploadInvoiceAttachment(selectedInvoiceId, file);
            setFiles([]);
            const result = await parseInboundInvoice(selectedInvoiceId);
            const warnings = result.warnings?.length ? ` Предупреждения: ${result.warnings.join("; ")}` : "";
            setMessage(`Накладная SNIMPORT залита: создано строк ${result.lines_created}.${warnings}`);
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось залить накладную SNIMPORT"));
        }
    };

    const importSnimportInvoiceToWarehouse = async () => {
        if (!isOwnWarehouseMode || !ownWarehouseId || !snimportInvoiceFile) {
            setError("Выберите накладную SNIMPORT в формате .xls или .xlsx");
            return;
        }
        if (!selectedSupplierId || !isSnimportWholesaleSupplier(selectedSupplier)) {
            setError("Для импорта выберите поставщика SNIMPORT");
            return;
        }
        setError("");
        setMessage("");
        setSnimportImporting(true);
        try {
            const result = await importOwnWarehouseSnimportInvoice(ownWarehouseId, {
                file: snimportInvoiceFile,
                supplierId: selectedSupplierId,
                markupPercent: invoiceDraft.markup_percent,
                retailPriceMode: invoiceDraft.retail_price_mode,
            });
            setSnimportInvoiceFile(null);
            setSelectedInvoiceId(String(result.invoice_id));
            setActiveTab("invoice_registry");
            setDetailOpen(true);
            const warnings = result.warnings?.length ? ` ${result.warnings.join("; ")}` : "";
            setMessage(result.duplicate
                ? `Открыта существующая накладная.${warnings}`
                : `Накладная залита: строк ${result.lines_created}, сопоставлено ${result.lines_mapped}, требуют маппинга ${result.lines_unmapped}.${warnings}`);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось залить накладную SNIMPORT"));
        } finally {
            setSnimportImporting(false);
        }
    };

    const runNpWmsCheck = async () => {
        setError("");
        setMessage("");
        try {
            const result = await checkNpWmsConnection();
            setNpWmsCheck(result);
            setMessage(result.wsdl_ok ? "NP WMS test contour доступен" : "NP WMS test contour не прошел проверку");
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка проверки NP WMS"));
        }
    };

    const runNpApiDiscovery = async () => {
        setError("");
        setMessage("");
        try {
            const result = await discoverNpApiFulfillmentRefs();
            setNpApiDiscovery(result);
            setMessage(`NP API refs: найдено отправителей ${result.senders_count || 0}`);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка получения NP API refs"));
        }
    };

    const runStockAudit = async (includeWms = false) => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await getInvoiceStockAudit(selectedInvoiceId, includeWms);
            setStockAudit(result);
            setMessage(includeWms ? "Остатки проверены локально и в WMS" : "Остатки проверены локально");
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка проверки остатков"));
        }
    };

    const runNpWmsPlanDryRun = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await buildNpWmsPlanDryRun(selectedInvoiceId);
            setNpWmsPlanDryRun(result);
            setMessage(`WMS plan dry-run подготовлен: ${result.lines_count} строк`);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка подготовки WMS plan dry-run"));
        }
    };

    const runNpWmsGoodsDryRun = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await buildNpWmsGoodsDryRun(selectedInvoiceId, { allow_default_dimensions: allowDefaultDimensions });
            setNpWmsGoodsDryRun(result);
            setMessage(`WMS goods dry-run подготовлен: ${result.lines_count} SKU`);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка подготовки WMS goods dry-run"));
        }
    };

    const runNpWmsSendAll = async () => {
        if (!selectedInvoiceId || npWmsSending) return;
        if (selectedInvoice.delivery_via_np == null) {
            setError("Выберите способ доставки: Новая Почта или другой перевозчик/самовывоз");
            return;
        }
        if (selectedInvoice.delivery_via_np && !String(selectedInvoice.np_tracking_number || "").trim()) {
            setError("Укажите номер экспресс-накладной Новой Почты");
            return;
        }
        if (!selectedInvoice.delivery_via_np && !selectedInvoice.expected_receipt_at) {
            setError("Укажите дату и время ожидаемой поставки");
            return;
        }
        setError("");
        setMessage("");
        setNpWmsSending(true);
        try {
            const result = await sendNpWmsGoodsAndPlan(selectedInvoiceId, { allow_default_dimensions: allowDefaultDimensions });
            setNpWmsSendResult(result.plan || result.goods || result);
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
            // Сообщение/ошибку выставляем ПОСЛЕ перезагрузок: loadBase() делает setError("").
            const goodsErrors = result.goods?.errors || [];
            const planErrors = result.plan?.errors || [];
            if (result.status === "goods_error" || goodsErrors.length) {
                setError(`NP WMS CreateUpdateGoods отклонён: ${goodsErrors.join("; ") || "нет текста ошибки, см. XML-ответ"}`);
            } else if (result.status === "send_unknown") {
                setError("NP WMS не вернул ответ после автоматической повторной попытки. План мог быть создан; повторная отправка использует тот же GUID и безопасно обновит его.");
            } else if (result.status === "send_failed" || planErrors.length) {
                setError(`NP WMS CreateUpdatePlanInbound отклонён: ${planErrors.join("; ") || "нет текста ошибки, см. XML-ответ"}`);
            } else {
                setMessage(`NP WMS goods + plan: ${result.status}`);
            }
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка отправки NP WMS goods + plan"));
        } finally {
            setNpWmsSending(false);
        }
    };

    const runNpWmsFactPoll = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await pollNpWmsFactInbound(selectedInvoiceId);
            setNpWmsFactResult(result);
            setMessage(`WMS fact poll: ${result.facts_count} фактов, stock events ${result.stock_events_created}`);
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка polling WMS fact"));
        }
    };

    const runNpWmsFactSimulation = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            const result = await simulateNpWmsFactPlaced(selectedInvoiceId);
            setNpWmsFactResult(result);
            setMessage(`Simulated placed fact: stock events ${result.stock_events_created}`);
            await runStockAudit(false);
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка имитации WMS fact"));
        }
    };

    const runProductSearch = async () => {
        const query = String(productSearch || "").trim();
        if (query.length < 2) {
            setProductResults([]);
            return;
        }
        setError("");
        try {
            setProductResults(await searchFulfillmentProducts(query));
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка поиска товара"));
        }
    };

    const selectProductForManualLine = (item) => {
        setManualLineDraft((prev) => ({
            ...prev,
            sku: item.sku || "",
            barcode: item.barcode || "",
            supplier_product_code: item.supplier_code || item.supplier_product_id || prev.supplier_product_code || "",
            supplier_product_name: item.supplier_product_name_raw || item.name_ua || item.name_ru || "",
            manufacturer: item.manufacturer || "",
            weight_g: item.weight_g || "",
            length_mm: item.length_mm || "",
            width_mm: item.width_mm || "",
            height_mm: item.height_mm || "",
        }));
    };

    const saveProductDimensions = async (sku, draft) => {
        const payload = {
            weight_g: draft.weight_g,
            length_mm: draft.length_mm,
            width_mm: draft.width_mm,
            height_mm: draft.height_mm,
        };
        if (!sku || !payload.weight_g || !payload.length_mm || !payload.width_mm || !payload.height_mm) {
            throw new Error("Заполни вес и все габариты товара");
        }
        return updateFulfillmentProductDimensions(sku, payload);
    };

    const addManualLine = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        try {
            await saveProductDimensions(manualLineDraft.sku, manualLineDraft);
            await createInvoiceLine(selectedInvoiceId, {
                ...manualLineDraft,
                qty_expected: manualLineDraft.qty_expected || "0",
                cost_price: manualLineDraft.cost_price || "0",
                vat_rate: (selectedInvoice?.vat_included && manualLineDraft.vat_rate) ? manualLineDraft.vat_rate : null,
                line_total: manualLineDraft.line_total || null,
                retail_price_manual: manualLineDraft.retail_price_manual || null,
                expiration_date: manualLineDraft.expiration_date || null,
            });
            setMessage("Позиция добавлена");
            setManualLineDraft({
                sku: "",
                supplier_product_code: "",
                supplier_product_name: "",
                barcode: "",
                manufacturer: "",
                qty_expected: "1",
                cost_price: "",
                vat_rate: "",
                line_total: "",
                retail_price_manual: "",
                expiration_date: "",
                batch_id: "",
                weight_g: "",
                length_mm: "",
                width_mm: "",
                height_mm: "",
            });
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка добавления позиции"));
        }
    };

    const resetLineDraft = (line) => {
        if (!line?.id) return;
        setLineDrafts((prev) => ({
            ...prev,
            [line.id]: {
                sku: line.mapped_sku || "",
                supplier_product_code: line.supplier_product_code || "",
                supplier_product_name: line.supplier_product_name || "",
                barcode: line.barcode || "",
                manufacturer: line.manufacturer || "",
                qty_expected: line.qty_expected || "",
                cost_price: line.cost_price || "",
                vat_rate: line.vat_rate ?? "",
                line_total: line.line_total || "",
                retail_price_manual: line.retail_price_manual || "",
                expiration_date: line.expiration_date || "",
                batch_id: line.batch_id || "",
            },
        }));
    };

    const cancelLineEdit = (line) => {
        resetLineDraft(line);
        setEditingLineIds((prev) => ({ ...prev, [line.id]: false }));
    };

    const saveLine = async (line) => {
        if (!selectedInvoiceId || !line?.id) return false;
        setError("");
        setMessage("");
        try {
            const draft = lineDrafts[line.id] || {};
            await updateInvoiceLine(selectedInvoiceId, line.id, {
                ...draft,
                sku: draft.sku || null,
                qty_expected: draft.qty_expected || null,
                cost_price: draft.cost_price || null,
                vat_rate: draft.vat_rate === "" ? null : draft.vat_rate,
                line_total: draft.line_total || null,
                retail_price_manual: draft.retail_price_manual || null,
                expiration_date: draft.expiration_date || null,
            });
            setMessage(`Позиция ${line.line_no} обновлена`);
            setEditingLineIds((prev) => ({ ...prev, [line.id]: false }));
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
            return true;
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка обновления позиции"));
            return false;
        }
    };

    const removeLine = async (line) => {
        if (!selectedInvoiceId || !line?.id) return;
        if (!window.confirm(`Удалить позицию ${line.line_no}?`)) return;
        setError("");
        setMessage("");
        try {
            await deleteInvoiceLine(selectedInvoiceId, line.id);
            setMessage(`Позиция ${line.line_no} удалена`);
            await loadInvoiceDetail(selectedInvoiceId);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка удаления позиции"));
        }
    };

    const missingDimensionLines = useMemo(
        () => (selectedInvoice?.lines || []).filter((line) => line.mapped_sku && !line.dimensions_complete),
        [selectedInvoice],
    );

    const invoiceTotals = useMemo(() => {
        const lines = selectedInvoice?.lines || [];
        return lines.reduce(
            (acc, line) => {
                const qty = Number(line.qty_expected) || 0;
                const lineTotal = Number(line.line_total) || 0;
                const costWithVat = Number(line.cost_price_with_vat) || 0;
                const retailPrice = Number(line.retail_price_manual || line.retail_price_preview) || 0;
                acc.count += 1;
                acc.qty += qty;
                acc.lineTotal += lineTotal;
                acc.costWithVatTotal += qty * costWithVat;
                acc.retailTotal += qty * retailPrice;
                return acc;
            },
            { count: 0, qty: 0, lineTotal: 0, costWithVatTotal: 0, retailTotal: 0 },
        );
    }, [selectedInvoice]);

    const saveDimensionDraft = async (sku) => {
        if (!sku) return;
        setError("");
        setMessage("");
        try {
            await saveProductDimensions(sku, dimensionDrafts[sku] || {});
            setMessage(`Габариты ${sku} сохранены`);
            await loadInvoiceDetail(selectedInvoiceId);
            if (npWmsGoodsDryRun) {
                await runNpWmsGoodsDryRun();
            }
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка сохранения габаритов"));
        }
    };

    const saveAllDimensionDrafts = async () => {
        setError("");
        setMessage("");
        try {
            const skus = Array.from(new Set(missingDimensionLines.map((line) => line.mapped_sku).filter(Boolean)));
            for (const sku of skus) {
                await saveProductDimensions(sku, dimensionDrafts[sku] || {});
            }
            setMessage(`Габариты сохранены: ${skus.length} SKU`);
            await loadInvoiceDetail(selectedInvoiceId);
            await runNpWmsGoodsDryRun();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка массового сохранения габаритов"));
        }
    };

    const renderWholesale = () => (
        <div className="suppliers-page">
            <div className="sp-split">
                <aside className="sp-card sp-picker">
                    <h2>Поставщики опт</h2>

                    <div className="sp-picker-actions">
                        <button type="button" className="sp-btn sp-btn-primary sp-btn-sm" onClick={createNewSupplier}>+ Новый</button>
                        <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={loadBase}>Обновить</button>
                    </div>

                    <label className="sp-switch-row">
                        <input type="checkbox" checked={showOnlyActiveSuppliers} onChange={(e) => setShowOnlyActiveSuppliers(e.target.checked)} />
                        <span>Только активные</span>
                    </label>

                    <div className="sp-sender-list">
                        {filteredSuppliers.map((item) => (
                            <button
                                key={item.id}
                                type="button"
                                onClick={() => {
                                    setWholesaleCreating(false);
                                    setSelectedSupplierId(String(item.id));
                                    setWholesaleDetailTab("details");
                                }}
                                className={String(item.id) === String(selectedSupplierId) && !wholesaleCreating ? "sp-sender-item sel" : "sp-sender-item"}
                            >
                                <span className="nm">{item.display_name || item.name}</span>
                                <span className="meta">Код: {item.code}</span>
                                <span className={item.is_active ? "sp-badge on" : "sp-badge off"}>
                                    <span className="dot" />{item.is_active ? "Активен" : "Неактивен"}
                                </span>
                            </button>
                        ))}
                        {filteredSuppliers.length === 0 ? <div className="sp-mini">Оптовые поставщики не найдены.</div> : null}
                    </div>
                </aside>

                <section className="sp-detail">
                    <div className="sp-tabbar" role="tablist" aria-label="Разделы оптового поставщика">
                        {[
                            ["details", "Основное"],
                            ["counterparties", "Контрагенты"],
                            ["content", "Контент"],
                            ["pricing", "Ценообразование"],
                        ].map(([key, label]) => (
                            <button key={key} type="button" role="tab" aria-selected={wholesaleDetailTab === key} className={wholesaleDetailTab === key ? "sp-tab active" : "sp-tab"} onClick={() => setWholesaleDetailTab(key)}>{label}</button>
                        ))}
                    </div>
                    {wholesaleDetailTab === "details" && (
                    <div className="sp-card">
                        <div className="sp-panel">
                            <h3>{wholesaleCreating ? "Новый оптовый поставщик" : "Карточка оптового поставщика"}</h3>
                            <div className="sp-block">
                                <div className="sp-bh"><span className="ic">ⓘ</span><h4>Реквизиты</h4></div>
                                <div className="sp-grid3">
                                    <div className="sp-fld"><label>Код</label><input className="sp-inp" value={supplierDraft.code} disabled={!wholesaleCreating} onChange={(e) => setSupplierDraft({ ...supplierDraft, code: e.target.value })} /></div>
                                    <div className="sp-fld"><label>Название</label><input className="sp-inp" value={supplierDraft.name} onChange={(e) => setSupplierDraft({ ...supplierDraft, name: e.target.value })} /></div>
                                    <div className="sp-fld"><label>Отображение</label><input className="sp-inp" value={supplierDraft.display_name} onChange={(e) => setSupplierDraft({ ...supplierDraft, display_name: e.target.value })} /></div>
                                    <div className="sp-fld"><label>Dropship runtime code</label><input className="sp-inp" value={supplierDraft.dropship_supplier_code} onChange={(e) => setSupplierDraft({ ...supplierDraft, dropship_supplier_code: e.target.value })} /></div>
                                    <div className="sp-fld"><label>Parser</label><input className="sp-inp" value={supplierDraft.default_parser_code} onChange={(e) => setSupplierDraft({ ...supplierDraft, default_parser_code: e.target.value })} /></div>
                                    <div className="sp-fld"><label>Default markup %</label><input className="sp-inp" value={supplierDraft.default_markup_percent} onChange={(e) => setSupplierDraft({ ...supplierDraft, default_markup_percent: e.target.value })} /></div>
                                    <button
                                        type="button"
                                        className={Boolean(supplierDraft.is_active) ? "sp-check ck" : "sp-check"}
                                        onClick={() => setSupplierDraft({ ...supplierDraft, is_active: !supplierDraft.is_active })}
                                    >
                                        <span className="box">{supplierDraft.is_active ? "✓" : ""}</span>
                                        <span>Активный</span>
                                    </button>
                                    <div className="sp-fld sp-col-span"><label>Заметки</label><input className="sp-inp" value={supplierDraft.notes} onChange={(e) => setSupplierDraft({ ...supplierDraft, notes: e.target.value })} /></div>
                                </div>
                            </div>
                            <div className="sp-save-bar">
                                <span className="note">Изменения касаются выбранного оптового поставщика</span>
                                <button type="button" className="sp-btn sp-btn-primary" onClick={saveSupplier}>{wholesaleCreating ? "Создать" : "Сохранить"}</button>
                            </div>
                        </div>
                    </div>
                    )}

                    {wholesaleDetailTab === "counterparties" && (
                    <div className="sp-card">
                        <div className="sp-panel">
                            <h3>Контрагенты оптового поставщика</h3>
                            <p className="lead">
                                {selectedSupplier ? (selectedSupplier.display_name || selectedSupplier.name) : "Выберите оптового поставщика."}
                            </p>
                            <div className="sp-block">
                                <div className="sp-bh"><span className="ic">⇄</span><h4>Связать контрагента</h4></div>
                                <div className="sp-form-grid" style={{ gridTemplateColumns: "minmax(240px, 1fr) auto" }}>
                                    <div className="sp-fld">
                                        <label>Контрагент</label>
                                        <select className="sp-inp" value={selectedCounterpartyId} onChange={(e) => setSelectedCounterpartyId(e.target.value)} disabled={!selectedSupplierId}>
                                            <option value="">Не выбран</option>
                                            {unlinkedCounterparties.map((counterparty) => (
                                                <option key={counterparty.id} value={counterparty.id}>
                                                    {counterparty.short_name || counterparty.legal_name}{counterparty.tax_id ? ` · ${counterparty.tax_id}` : ""}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <button type="button" className="sp-btn sp-btn-primary" style={{ alignSelf: "end" }} onClick={addCounterpartyLink} disabled={!selectedSupplierId || !selectedCounterpartyId}>Связать</button>
                                </div>
                            </div>
                            <div className="sp-tbl-wrap">
                                <table className="sp-tbl">
                                    <thead><tr><th>Контрагент</th><th>ЕДРПОУ</th><th>Default</th><th></th></tr></thead>
                                    <tbody>
                                        {linkedCounterparties.map(({ counterparty, link }) => (
                                            <tr key={link.id}>
                                                <td>{counterparty.short_name || counterparty.legal_name}</td>
                                                <td>{counterparty.tax_id || "—"}</td>
                                                <td>{link.is_default ? <span className="sp-pill g">Да</span> : ""}</td>
                                                <td><button type="button" className="sp-btn sp-btn-soft-danger sp-btn-sm" onClick={() => removeCounterpartyLink(counterparty.id, link.id)}>Убрать связь</button></td>
                                            </tr>
                                        ))}
                                        {linkedCounterparties.length === 0 ? (
                                            <tr><td colSpan={4} className="sp-mini">Контрагенты пока не связаны.</td></tr>
                                        ) : null}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    )}
                    {wholesaleDetailTab === "content" && (
                    <div className="sp-card"><div className="sp-panel">
                        <h3>Контент оптовика</h3><p className="lead">Фид используется только для контента и кодов; остатки и цены здесь не загружаются.</p>
                        {isSnimportWholesaleSupplier(selectedSupplier) && (
                            <div className="sp-block">
                                <div className="sp-bh"><span className="ic">⇪</span><h4>Ручной импорт прайса SNIMPORT</h4></div>
                                <p className="sp-mini">Загрузит названия, артикулы, ШК и ссылки на фото в master catalog. Цены и остатки не изменяются.</p>
                                <div className="sp-form-grid" style={{ gridTemplateColumns: "minmax(260px, 1fr) auto" }}>
                                    <input className="sp-inp" type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(event) => { setSnimportContentFile(event.target.files?.[0] || null); setSnimportContentResult(null); }} />
                                    <button type="button" className="sp-btn sp-btn-primary" disabled={!snimportContentFile || snimportContentImporting} onClick={async () => {
                                        setSnimportContentImporting(true); setError(""); setMessage("");
                                        try {
                                            const result = await importSnimportWholesaleContent(selectedSupplierId, snimportContentFile);
                                            setSnimportContentResult(result);
                                            setMessage("Прайс SNIMPORT импортирован");
                                        } catch (err) { setError(apiErrorMessage(err, "Не удалось импортировать прайс SNIMPORT")); }
                                        finally { setSnimportContentImporting(false); }
                                    }}>{snimportContentImporting ? "Импорт…" : "Импортировать XLSX"}</button>
                                </div>
                                {snimportContentResult && <div className="sp-grid4" style={{ marginTop: "12px" }}>
                                    <div><span className="sp-mini">Строк</span><strong>{snimportContentResult.rows_read}</strong></div>
                                    <div><span className="sp-mini">Маппингов</span><strong>{snimportContentResult.mappings_inserted + snimportContentResult.mappings_updated}</strong></div>
                                    <div><span className="sp-mini">Добавлено фото</span><strong>{snimportContentResult.images_inserted}</strong></div>
                                    <div><span className="sp-mini">Без ШК / фото</span><strong>{snimportContentResult.rows_without_barcode} / {snimportContentResult.rows_without_image}</strong></div>
                                    <div><span className="sp-mini">Неоднозначных ШК</span><strong>{snimportContentResult.barcodes_ambiguous_master + snimportContentResult.barcodes_ambiguous_supplier}</strong></div>
                                    <div><span className="sp-mini">Конфликтов mapping</span><strong>{snimportContentResult.mappings_conflicting_existing}</strong></div>
                                    <div><span className="sp-mini">Имена: магазин / предприятие</span><strong>{snimportContentResult.identity_sync?.created_store_names || 0} / {snimportContentResult.identity_sync?.created_enterprise_names || 0}</strong></div>
                                </div>}
                            </div>
                        )}
                        <div className="sp-grid3">
                            <div className="sp-fld"><label>Название</label><input className="sp-inp" value={contentDraft.name} onChange={(e) => setContentDraft({ ...contentDraft, name: e.target.value })} /></div>
                            <div className="sp-fld"><label>Формат</label><select className="sp-inp" value={contentDraft.format_code} onChange={(e) => setContentDraft({ ...contentDraft, format_code: e.target.value })}><option value="auto">Авто</option><option value="yml">YML</option><option value="xml">XML</option><option value="csv">CSV</option><option value="xlsx">XLSX</option></select></div>
                            <div className="sp-fld"><label>URL фида</label><input className="sp-inp" value={contentDraft.source_url} onChange={(e) => setContentDraft({ ...contentDraft, source_url: e.target.value })} /></div>
                        </div>
                        <button type="button" className="sp-btn sp-btn-primary" disabled={!selectedSupplierId || !contentDraft.name || !contentDraft.source_url} onClick={async () => { try { await createWholesaleContentSource(selectedSupplierId, contentDraft); setContentDraft({ name: "", source_type: "url", format_code: "auto", source_url: "" }); setContentSources(await listWholesaleContentSources(selectedSupplierId)); } catch (err) { setError(apiErrorMessage(err, "Не удалось добавить источник")); } }}>Добавить источник</button>
                        <div className="sp-tbl-wrap" style={{ marginTop: "12px" }}><table className="sp-tbl"><thead><tr><th>Источник</th><th>Формат</th><th>Статус</th><th></th></tr></thead><tbody>{contentSources.map((source) => {
                            const identitySync = contentImportResults[source.id];
                            return <tr key={source.id}><td>{source.name}<div className="sp-mini">{source.source_url}</div></td><td>{source.format_code}</td><td>{source.last_status || "ещё не запускался"}{identitySync && <div className="sp-mini">Имена: магазин {identitySync.created_store_names || 0}, предприятие {identitySync.created_enterprise_names || 0}</div>}</td><td><button className="sp-btn sp-btn-ghost sp-btn-sm" onClick={async () => { try { const result = await runWholesaleContentSource(source.id); setContentImportResults((current) => ({ ...current, [source.id]: result.identity_sync || {} })); setContentSources(await listWholesaleContentSources(selectedSupplierId)); const sync = result.identity_sync || {}; setMessage(`Импорт контента завершён. Создано external names: магазин ${sync.created_store_names || 0}, предприятие ${sync.created_enterprise_names || 0}`); } catch (err) { setError(apiErrorMessage(err, "Ошибка импорта контента")); } }}>Импортировать</button></td></tr>;
                        })}{!contentSources.length && <tr><td colSpan={4} className="sp-mini">Источников пока нет.</td></tr>}</tbody></table></div>
                    </div></div>
                    )}
                    {wholesaleDetailTab === "pricing" && (
                    <div className="sp-card"><div className="sp-panel">
                        <h3>Фулфилмент и правила цены</h3>
                        <p className="lead">Правила принадлежат связке этого оптовика с отправителем фулфилмента. Пустое значение наследует базовое правило sender; оно не меняется настройками отдельных магазинов.</p>
                        <div className="sp-grid3">
                            <div className="sp-fld"><label>Фулфилмент sender</label><select className="sp-inp" value={routeDraft.fulfillment_sender_code} onChange={(e) => setRouteDraft({ ...routeDraft, fulfillment_sender_code: e.target.value })}><option value="">— выбрать —</option>{supplierConfigs.map((item) => <option key={item.id} value={item.supplier_code}>{item.supplier_code}</option>)}</select></div>
                            <div className="sp-fld"><label>РРЦ</label><select className="sp-inp" value={routeDraft.is_rrp} onChange={(e) => setRouteDraft({ ...routeDraft, is_rrp: e.target.value })}><option value="inherit">Наследовать sender</option><option value="true">Использовать РРЦ</option><option value="false">Не использовать РРЦ</option></select></div>
                            <div className="sp-fld"><label>Приоритет</label><input className="sp-inp" type="number" value={routeDraft.priority_override} placeholder="Наследовать sender" onChange={(e) => setRouteDraft({ ...routeDraft, priority_override: e.target.value })} /></div>
                            <div className="sp-fld"><label>Мин. наценка, %</label><input className="sp-inp" type="number" value={routeDraft.min_markup_threshold} placeholder="Наследовать sender" onChange={(e) => setRouteDraft({ ...routeDraft, min_markup_threshold: e.target.value })} /></div>
                            <div className="sp-fld"><label>Демпинг</label><select className="sp-inp" value={routeDraft.dumping_mode} onChange={(e) => setRouteDraft({ ...routeDraft, dumping_mode: e.target.value })}><option value="inherit">Наследовать sender</option><option value="true">Разрешён</option><option value="false">Запрещён</option></select></div>
                            <div className="sp-fld"><label>Доп. наценка</label><select className="sp-inp" value={routeDraft.extra_markup_enabled} onChange={(e) => setRouteDraft({ ...routeDraft, extra_markup_enabled: e.target.value })}><option value="inherit">Наследовать sender</option><option value="true">Включена</option><option value="false">Выключена</option></select></div>
                            <div className="sp-fld"><label>Значение доп. наценки, %</label><input className="sp-inp" type="number" value={routeDraft.extra_markup_value} onChange={(e) => setRouteDraft({ ...routeDraft, extra_markup_value: e.target.value })} /></div>
                            <div className="sp-fld"><label>Мин. цена для наценки</label><input className="sp-inp" type="number" value={routeDraft.extra_markup_min} onChange={(e) => setRouteDraft({ ...routeDraft, extra_markup_min: e.target.value })} /></div>
                            <div className="sp-fld"><label>Макс. цена для наценки</label><input className="sp-inp" type="number" value={routeDraft.extra_markup_max} onChange={(e) => setRouteDraft({ ...routeDraft, extra_markup_max: e.target.value })} /></div>
                        </div>
                        <button type="button" className="sp-btn sp-btn-primary" disabled={!selectedSupplierId || !routeDraft.fulfillment_sender_code} onClick={createWholesaleRoute}>Добавить маршрут с правилами</button>
                        <div className="sp-tbl-wrap" style={{ marginTop: "14px" }}><table className="sp-tbl"><thead><tr><th>Sender</th><th>Статус</th><th>РРЦ / приоритет</th><th>Мин. наценка</th><th>Доп. наценка</th><th></th></tr></thead><tbody>
                            {fulfillmentRoutes.filter((route) => String(route.wholesale_supplier_id) === String(selectedSupplierId)).map((route) => {
                                const edit = routeEdits[route.id] || routeEditFrom(route);
                                const setEdit = (patch) => setRouteEdits((prev) => ({ ...prev, [route.id]: { ...edit, ...patch } }));
                                return <tr key={route.id}><td>{route.fulfillment_sender_code}</td><td><label className="sp-switch-row"><input type="checkbox" checked={edit.is_active} onChange={(e) => setEdit({ is_active: e.target.checked })} /><span>{edit.is_active ? "Активен" : "Отключён"}</span></label></td><td><select className="sp-inp" value={edit.is_rrp} onChange={(e) => setEdit({ is_rrp: e.target.value })}><option value="inherit">sender</option><option value="true">РРЦ</option><option value="false">без РРЦ</option></select><input className="sp-inp" style={{ marginTop: "6px" }} type="number" value={edit.priority_override} placeholder="Приоритет sender" onChange={(e) => setEdit({ priority_override: e.target.value })} /></td><td><input className="sp-inp" type="number" value={edit.min_markup_threshold} placeholder="sender" onChange={(e) => setEdit({ min_markup_threshold: e.target.value })} /><select className="sp-inp" style={{ marginTop: "6px" }} value={edit.dumping_mode} onChange={(e) => setEdit({ dumping_mode: e.target.value })}><option value="inherit">Демпинг sender</option><option value="true">Демпинг да</option><option value="false">Демпинг нет</option></select></td><td><select className="sp-inp" value={edit.extra_markup_enabled} onChange={(e) => setEdit({ extra_markup_enabled: e.target.value })}><option value="inherit">sender</option><option value="true">Включена</option><option value="false">Выключена</option></select><input className="sp-inp" style={{ marginTop: "6px" }} type="number" value={edit.extra_markup_value} placeholder="%" onChange={(e) => setEdit({ extra_markup_value: e.target.value })} /><div style={{ display: "flex", gap: "6px", marginTop: "6px" }}><input className="sp-inp" type="number" value={edit.extra_markup_min} placeholder="от" onChange={(e) => setEdit({ extra_markup_min: e.target.value })} /><input className="sp-inp" type="number" value={edit.extra_markup_max} placeholder="до" onChange={(e) => setEdit({ extra_markup_max: e.target.value })} /></div></td><td><button type="button" className="sp-btn sp-btn-primary sp-btn-sm" onClick={() => saveWholesaleRoute(route)}>Сохранить</button></td></tr>;
                            })}
                            {!fulfillmentRoutes.some((route) => String(route.wholesale_supplier_id) === String(selectedSupplierId)) && <tr><td colSpan={6} className="sp-mini">Маршрутов для этого оптовика пока нет.</td></tr>}
                        </tbody></table></div>
                    </div></div>
                    )}
                </section>
            </div>
        </div>
    );

    const renderLegal = () => (
        <section style={{ display: "grid", gridTemplateColumns: "360px 1fr", gap: "16px", alignItems: "start" }}>
            <div style={panelStyle}>
                <h2 style={{ marginTop: 0, fontSize: "17px" }}>Поставщик</h2>
                <select style={inputStyle} value={selectedSupplierId} onChange={(e) => setSelectedSupplierId(e.target.value)}>
                    <option value="">Не выбран</option>
                    {suppliers.map((item) => <option key={item.id} value={item.id}>{item.display_name || item.name}</option>)}
                </select>
                {selectedSupplier && <p style={{ ...mutedStyle, marginTop: "10px" }}>{selectedSupplier.code}</p>}
            </div>
            <div style={panelStyle}>
                <h2 style={{ marginTop: 0, fontSize: "17px" }}>Юрлица выбранного поставщика</h2>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(160px, 1fr)) auto", gap: "10px", alignItems: "end" }}>
                    <Field label="Юрлицо"><input style={inputStyle} value={legalDraft.legal_name} onChange={(e) => setLegalDraft({ ...legalDraft, legal_name: e.target.value })} /></Field>
                    <Field label="Короткое имя"><input style={inputStyle} value={legalDraft.short_name} onChange={(e) => setLegalDraft({ ...legalDraft, short_name: e.target.value })} /></Field>
                    <Field label="ЕДРПОУ/ИНН"><input style={inputStyle} value={legalDraft.tax_id} onChange={(e) => setLegalDraft({ ...legalDraft, tax_id: e.target.value })} /></Field>
                    <Field label="Телефон"><input style={inputStyle} value={legalDraft.phone} onChange={(e) => setLegalDraft({ ...legalDraft, phone: e.target.value })} /></Field>
                    <button style={primaryButtonStyle} onClick={saveLegalEntity} disabled={!selectedSupplierId}>Добавить</button>
                </div>
                <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "14px" }}>
                    <thead><tr><th style={thStyle}>Юрлицо</th><th style={thStyle}>Короткое имя</th><th style={thStyle}>Tax ID</th><th style={thStyle}>Default</th></tr></thead>
                    <tbody>{legalEntities.map((item) => <tr key={item.id}><td style={tdStyle}>{item.legal_name}</td><td style={tdStyle}>{item.short_name}</td><td style={tdStyle}>{item.tax_id}</td><td style={tdStyle}>{item.is_default ? "yes" : ""}</td></tr>)}</tbody>
                </table>
            </div>
        </section>
    );

    // ---- own_warehouse: проведение накладной в остатки склада ----
    const invoicePosted = isOwnWarehouseMode && String(selectedInvoice?.status || "") === "posted";
    const runPostingPreview = async () => {
        if (!selectedInvoiceId) return;
        setError("");
        setMessage("");
        setPostingBusy(true);
        try {
            setPostingPreview(await getOwnWarehouseInvoicePostingPreview(selectedInvoiceId));
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка предпросмотра проведения"));
        } finally {
            setPostingBusy(false);
        }
    };
    const postInvoiceToWarehouse = async () => {
        if (!selectedInvoiceId) return;
        if (!window.confirm("Провести накладную? Партии будут приняты на склад.")) return;
        setError("");
        setMessage("");
        setPostingBusy(true);
        try {
            const report = await postOwnWarehouseInvoice(selectedInvoiceId);
            setPostingReport(report);
            setPostingPreview(null);
            setMessage(`Накладная проведена: строк ${report?.posted_lines ?? "—"}`);
            await loadInvoiceDetail(selectedInvoiceId);
            setPostingReport(report);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка проведения накладной"));
        } finally {
            setPostingBusy(false);
        }
    };
    const unpostInvoiceFromWarehouse = async () => {
        if (!selectedInvoiceId) return;
        if (!window.confirm("Отменить проведение? Партии этой накладной будут сняты с остатков.")) return;
        setError("");
        setMessage("");
        setPostingBusy(true);
        try {
            const report = await unpostOwnWarehouseInvoice(selectedInvoiceId);
            setMessage("Проведение отменено");
            await loadInvoiceDetail(selectedInvoiceId);
            setPostingReport(report || null);
            await loadBase();
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка отмены проведения"));
        } finally {
            setPostingBusy(false);
        }
    };
    const renderPostingPanel = () => {
        if (!selectedInvoice) return null;
        const previewLines = postingPreview?.lines || [];
        return (
            <div className="sp-block">
                <div className="sp-bh">
                    <span className="ic">✓</span>
                    <h4>Проведение</h4>
                    <span className="hint">склад {ownWarehouseCode || `#${ownWarehouseId}`}</span>
                </div>
                <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                    {invoicePosted ? (
                        <span className="sp-pill g">Проведена{selectedInvoice.posted_at ? ` · ${new Date(selectedInvoice.posted_at).toLocaleString()}` : ""}{selectedInvoice.posted_by ? ` · ${selectedInvoice.posted_by}` : ""}</span>
                    ) : (
                        <span className="sp-pill warn">Не проведена</span>
                    )}
                    {!invoicePosted && <button type="button" className="sp-btn sp-btn-ghost" onClick={runPostingPreview} disabled={postingBusy}>Предпросмотр проведения</button>}
                    {!invoicePosted && <button type="button" className="sp-btn sp-btn-primary" onClick={postInvoiceToWarehouse} disabled={postingBusy || (postingPreview && postingPreview.can_post === false)}>Провести</button>}
                    {invoicePosted && <button type="button" className="sp-btn sp-btn-soft-danger" onClick={unpostInvoiceFromWarehouse} disabled={postingBusy}>Отменить проведение</button>}
                    {invoicePosted && <span className="sp-hint">Строки проведённой накладной заблокированы — сначала отмените проведение.</span>}
                </div>
                {postingPreview && (
                    <div style={{ display: "grid", gap: "8px", marginTop: "12px" }}>
                        {postingPreview.can_post === false && <div className="sp-msg err">Проведение невозможно: {postingPreview.reason || "см. предупреждения"}</div>}
                        {(postingPreview.warnings || []).length > 0 && (
                            <div className="sp-warnbox">{postingPreview.warnings.map((item, index) => <span key={`${index}-${item}`}>{item}</span>)}</div>
                        )}
                        <div className="sp-tbl-wrap">
                            <table className="sp-tbl">
                                <thead><tr><th>SKU</th><th>Название</th><th>Кол-во</th><th>Себестоимость с НДС</th><th>НДС %</th><th>Срок</th><th>Розница</th><th>Источник цены</th><th>Предупреждения</th></tr></thead>
                                <tbody>
                                    {previewLines.map((line) => (
                                        <tr key={line.line_id || line.sku}>
                                            <td className="sp-strong">{line.sku || "—"}</td>
                                            <td>{line.name || "—"}</td>
                                            <td>{line.qty}</td>
                                            <td>{line.unit_cost}</td>
                                            <td>{line.vat_rate ?? "—"}</td>
                                            <td className="sp-mini">{line.expiration_date || "—"}</td>
                                            <td>{line.retail_price ?? "—"}</td>
                                            <td>{line.retail_price_source ? <span className="sp-pill">{line.retail_price_source}</span> : "—"}</td>
                                            <td>{(line.warnings || []).length ? <span className="sp-msg err">{line.warnings.join("; ")}</span> : <span className="sp-mini">—</span>}</td>
                                        </tr>
                                    ))}
                                    {previewLines.length === 0 && <tr><td className="sp-mini" colSpan={9}>Нет строк к проведению</td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                {postingReport && (
                    <div style={{ display: "grid", gap: "6px", marginTop: "12px" }}>
                        <strong style={{ fontSize: "13px" }}>Отчёт о проведении</strong>
                        <span className="sp-hint">Проведено строк: {postingReport.posted_lines ?? "—"}; пропущено: {Array.isArray(postingReport.skipped) ? postingReport.skipped.length : (postingReport.skipped ?? 0)}; партий: {Array.isArray(postingReport.batches) ? postingReport.batches.length : (postingReport.batches ?? "—")}</span>
                        {(postingReport.warnings || []).length > 0 && (
                            <div className="sp-warnbox">{postingReport.warnings.map((item, index) => <span key={`${index}-${String(item)}`}>{typeof item === "string" ? item : JSON.stringify(item)}</span>)}</div>
                        )}
                        {Array.isArray(postingReport.skipped) && postingReport.skipped.length > 0 && (
                            <div className="sp-hint">Пропущено: {postingReport.skipped.map((item) => (typeof item === "string" ? item : `${item.sku || item.line_id || "?"}: ${item.reason || ""}`)).join("; ")}</div>
                        )}
                    </div>
                )}
            </div>
        );
    };

    const renderOwnWarehouseInvoiceForm = () => (
        <div className="suppliers-page">
            <div className="sp-card sp-panel">
                <h3>Новая накладная на склад {ownWarehouseCode || `#${ownWarehouseId}`}</h3>
                <p className="lead">
                    Приход на собственный склад: файл поставщика (существующие парсеры) или ручной ввод строк. После заполнения строк накладная проводится в партии склада — отправка в NP WMS не используется.
                </p>
                <div className="sp-block">
                    <div className="sp-bh"><span className="ic">📄</span><h4>Основные данные</h4></div>
                    <div className="sp-grid3">
                        <div className="sp-fld">
                            <label>Поставщик</label>
                            <select className="sp-inp" value={selectedSupplierId} onChange={(e) => setSelectedSupplierId(e.target.value)}>
                                <option value="">Не выбран</option>
                                {suppliers.map((item) => <option key={item.id} value={item.id}>{item.display_name || item.name}</option>)}
                            </select>
                        </div>
                        <div className="sp-fld"><label>Номер</label><input className="sp-inp" value={invoiceDraft.invoice_number} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, invoice_number: e.target.value })} /></div>
                        <div className="sp-fld"><label>Дата</label><input type="date" className="sp-inp" value={invoiceDraft.invoice_date} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, invoice_date: e.target.value })} /></div>
                        <div className="sp-fld"><label>Ожидаемая дата поставки</label><input type="datetime-local" className="sp-inp" value={invoiceDraft.expected_receipt_at} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, expected_receipt_at: e.target.value })} /></div>
                    </div>
                </div>
                <div className="sp-block">
                    <div className="sp-bh"><span className="ic">₴</span><h4>Ценообразование</h4></div>
                    <div className="sp-grid3">
                        <div className="sp-fld"><label>НДС</label><select className="sp-inp" value={invoiceDraft.vat_included ? "with_vat" : "without_vat"} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, vat_included: e.target.value === "with_vat" })}><option value="with_vat">С НДС</option><option value="without_vat">Без НДС</option></select></div>
                        {invoiceDraft.vat_included && (
                            <div className="sp-fld"><label>Ставка НДС, %</label><input type="number" className="sp-inp" value={invoiceDraft.default_vat_rate} placeholder="20 или 7" onChange={(e) => setInvoiceDraft({ ...invoiceDraft, default_vat_rate: e.target.value })} /></div>
                        )}
                        <div className="sp-fld"><label>Базовая розничная цена</label><select className="sp-inp" value={invoiceDraft.retail_price_mode} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, retail_price_mode: e.target.value })}><option value="markup_percent">Расчет через % к себестоимости</option><option value="manual">Установка вручную по строкам</option></select></div>
                        <div className="sp-fld"><label>% наценки</label><input type="number" className="sp-inp" value={invoiceDraft.markup_percent} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, markup_percent: e.target.value })} disabled={invoiceDraft.retail_price_mode !== "markup_percent"} /></div>
                    </div>
                </div>
                <div className="sp-block">
                    <div className="sp-bh"><span className="ic">⇪</span><h4>Импорт накладной SNIMPORT</h4></div>
                    <p className="sp-hint">Файл сам заполнит номер, дату, НДС и строки. Внешние артикулы будут сопоставлены с нашими SKU; остатки изменятся только после отдельного проведения.</p>
                    <div className="sp-form-grid" style={{ gridTemplateColumns: "minmax(260px, 1fr) auto" }}>
                        <div className="sp-fld"><label>Накладная .xls / .xlsx</label><input type="file" accept=".xls,.xlsx" onChange={(e) => setSnimportInvoiceFile(e.target.files?.[0] || null)} /></div>
                        <button
                            type="button"
                            className="sp-btn sp-btn-primary"
                            onClick={importSnimportInvoiceToWarehouse}
                            disabled={!snimportInvoiceFile || !selectedSupplierId || !isSnimportWholesaleSupplier(selectedSupplier) || snimportImporting}
                        >{snimportImporting ? "Загрузка…" : "Залить накладную"}</button>
                    </div>
                    {selectedSupplierId && !isSnimportWholesaleSupplier(selectedSupplier) ? <div className="sp-msg err" style={{ marginTop: "10px" }}>Для этого импорта выберите SNIMPORT в поле «Поставщик».</div> : null}
                </div>
                <div className="sp-save-bar">
                    <span className="note">Или создайте пустую накладную для ручного ввода строк. Базовая цена попадает в склад при проведении.</span>
                    <button type="button" className="sp-btn sp-btn-primary" onClick={saveInvoice} disabled={!selectedSupplierId}>Создать накладную</button>
                </div>
            </div>
        </div>
    );

    const renderOwnWarehouseRegistryList = () => {
        const q = (registryFilters.search || "").trim().toLowerCase();
        const rows = invoices.filter((item) => {
            if (registryFilters.status && String(item.status || "") !== registryFilters.status) return false;
            if (q && !`${item.invoice_number || ""} ${item.supplier_name || ""}`.toLowerCase().includes(q)) return false;
            return true;
        });
        const postedCount = invoices.filter((i) => String(i.status || "") === "posted").length;
        const statusOptions = uniqueSortedValues(invoices.map((i) => i.status));
        return (
            <div className="suppliers-page">
                <div className="sp-card sp-toolbar">
                    <div className="sp-toolbar-head">
                        <div>
                            <h2 className="sp-h2">Накладные склада {ownWarehouseCode || `#${ownWarehouseId}`}</h2>
                            <p className="sp-hint" style={{ marginTop: "6px" }}>Показано {rows.length} из {invoices.length}</p>
                        </div>
                        <div className="sp-toolbar-actions">
                            <div className="sp-stats">
                                <span className="sp-stat">Всего <span>{invoices.length}</span></span>
                                <span className={postedCount > 0 ? "sp-stat" : "sp-stat zero"}>Проведено <span>{postedCount}</span></span>
                                <span className={invoices.length - postedCount > 0 ? "sp-stat warn" : "sp-stat zero"}>Не проведено <span>{invoices.length - postedCount}</span></span>
                            </div>
                            <button type="button" className="sp-btn sp-btn-primary sp-btn-sm" onClick={() => setActiveTab("invoice_form")}>Новая накладная</button>
                        </div>
                    </div>
                    <div className="sp-form-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))" }}>
                        <div className="sp-fld"><label>Статус</label><select className="sp-inp" value={registryFilters.status} onChange={(e) => setRegistryFilters((prev) => ({ ...prev, status: e.target.value }))}><option value="">— все —</option>{statusOptions.map((st) => <option key={st} value={st}>{st}</option>)}</select></div>
                        <div className="sp-fld"><label>Поиск (номер / поставщик)</label><input className="sp-inp" value={registryFilters.search} onChange={(e) => setRegistryFilters((prev) => ({ ...prev, search: e.target.value }))} /></div>
                    </div>
                </div>
                <div className="sp-tbl-wrap">
                    <table className="sp-tbl">
                        <thead><tr><th>ID</th><th>Поставщик</th><th>Номер</th><th>Дата</th><th>Статус</th><th>Проведена</th><th>Файлы</th><th>Строки</th></tr></thead>
                        <tbody>{rows.map((item) => (
                            <tr key={item.id} onClick={() => openInvoiceDetail(item.id)} className={String(item.id) === String(selectedInvoiceId) ? "sp-click sel" : "sp-click"}>
                                <td className="sp-strong">{item.id}</td>
                                <td>{item.supplier_name}</td>
                                <td>{item.invoice_number}</td>
                                <td className="sp-mini">{item.invoice_date}</td>
                                <td><span className="sp-pill">{item.status}</span></td>
                                <td>{String(item.status || "") === "posted" ? <span className="sp-pill g">{item.posted_at ? new Date(item.posted_at).toLocaleDateString() : "да"}</span> : <span className="sp-pill warn">нет</span>}</td>
                                <td>{item.attachments_count}</td>
                                <td>{item.lines_count}</td>
                            </tr>
                        ))}
                        {rows.length === 0 && <tr><td className="sp-mini" colSpan={8}>Накладных по этому складу пока нет</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderInvoiceForm = () => (isOwnWarehouseMode ? renderOwnWarehouseInvoiceForm() : (
        <div className="suppliers-page">
            <div className="sp-card sp-panel">
                <h3>Новая накладная</h3>
                <p className="lead">
                    Обычный продовый сценарий: план приема создается из этой накладной, WMS режим manual, склад берется из NP_WMS_DEST_WAREHOUSE. Номер существующего плана нужен только если план уже был создан вне этого UI.
                </p>
                <div className="sp-block">
                    <div className="sp-bh"><span className="ic">📄</span><h4>Основные данные</h4></div>
                    <div className="sp-grid3">
                        <div className="sp-fld">
                            <label>Поставщик</label>
                            <select className="sp-inp" value={selectedSupplierId} onChange={(e) => setSelectedSupplierId(e.target.value)}>
                                <option value="">Не выбран</option>
                                {suppliers.map((item) => <option key={item.id} value={item.id}>{item.display_name || item.name}</option>)}
                            </select>
                        </div>
                        <div className="sp-fld"><label>Номер</label><input className="sp-inp" value={invoiceDraft.invoice_number} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, invoice_number: e.target.value })} /></div>
                        <div className="sp-fld"><label>Дата</label><input type="date" className="sp-inp" value={invoiceDraft.invoice_date} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, invoice_date: e.target.value })} /></div>
                        <div className="sp-fld">
                            <label>Юрлицо (контур фулфилмента)</label>
                            <select
                                className="sp-inp"
                                value={invoiceDraft.business_organization_id}
                                onChange={(e) => {
                                    const orgId = e.target.value;
                                    const mapped = warehouseEntities.find((item) => String(item.business_organization_id) === String(orgId) && item.is_active);
                                    setInvoiceDraft((prev) => ({
                                        ...prev,
                                        business_organization_id: orgId,
                                        np_dest_warehouse: prev.np_dest_warehouse || (mapped ? mapped.warehouse : prev.np_dest_warehouse),
                                    }));
                                }}
                            >
                                <option value="">— по умолчанию (контур Петренко) —</option>
                                {businessOrganizations.map((org) => (
                                    <option key={org.id} value={org.id}>{org.short_name || org.full_name || `#${org.id}`}</option>
                                ))}
                            </select>
                        </div>
                        <div className="sp-fld"><label><input type="checkbox" checked={invoiceDraft.delivery_via_np} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, delivery_via_np: e.target.checked, np_tracking_number: e.target.checked ? invoiceDraft.np_tracking_number : "", expected_receipt_at: e.target.checked ? "" : invoiceDraft.expected_receipt_at })} /> Доставка Новой Почтой</label></div>
                        {invoiceDraft.delivery_via_np ? (
                            <div className="sp-fld"><label>ТТН Новой Почты *</label><input required className="sp-inp" value={invoiceDraft.np_tracking_number} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, np_tracking_number: e.target.value })} /></div>
                        ) : (
                            <div className="sp-fld"><label>Ожидаемая дата и время поставки *</label><input required type="datetime-local" className="sp-inp" value={invoiceDraft.expected_receipt_at} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, expected_receipt_at: e.target.value })} /></div>
                        )}
                        <div className="sp-fld"><label>Склад NP</label><input className="sp-inp" value={invoiceDraft.np_dest_warehouse} placeholder={runtimeConfig.np_wms_default_dest_warehouse || "NP_WMS_DEST_WAREHOUSE"} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, np_dest_warehouse: e.target.value })} /></div>
                    </div>
                </div>
                <div className="sp-block">
                    <div className="sp-bh"><span className="ic">⚙</span><h4>Приём на WMS и ценообразование</h4></div>
                    <div className="sp-grid3">
                        <div className="sp-fld"><label>WMS режим</label><select className="sp-inp" value={invoiceDraft.wms_send_mode} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, wms_send_mode: e.target.value })}><option value="manual">Ручная отправка</option><option value="auto">Авто после сохранения</option></select></div>
                        <div className="sp-fld"><label>План приема</label><select className="sp-inp" value={invoiceDraft.wms_plan_source} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, wms_plan_source: e.target.value })}><option value="created_by_us">Создать в NP из этой накладной</option><option value="external_existing">Уже создан вне UI</option></select></div>
                        {invoiceDraft.wms_plan_source === "external_existing" && (
                            <div className="sp-fld"><label>Номер плана в NP</label><input className="sp-inp" value={invoiceDraft.external_np_plan_ref} placeholder="ExternalNumber; GUID только если он известен" onChange={(e) => setInvoiceDraft({ ...invoiceDraft, external_np_plan_ref: e.target.value })} /></div>
                        )}
                        {invoiceDraft.wms_plan_source === "external_existing" && (
                            <div className="sp-fld"><label>SalesDrive invoice id</label><input className="sp-inp" value={invoiceDraft.external_salesdrive_invoice_id} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, external_salesdrive_invoice_id: e.target.value })} /></div>
                        )}
                        <div className="sp-fld"><label>НДС</label><select className="sp-inp" value={invoiceDraft.vat_included ? "with_vat" : "without_vat"} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, vat_included: e.target.value === "with_vat" })}><option value="with_vat">С НДС</option><option value="without_vat">Без НДС</option></select></div>
                        {invoiceDraft.vat_included && (
                            <div className="sp-fld"><label>Ставка НДС, %</label><input type="number" className="sp-inp" value={invoiceDraft.default_vat_rate} placeholder="20 или 7" onChange={(e) => setInvoiceDraft({ ...invoiceDraft, default_vat_rate: e.target.value })} /></div>
                        )}
                        <div className="sp-fld"><label>Розничная цена</label><select className="sp-inp" value={invoiceDraft.retail_price_mode} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, retail_price_mode: e.target.value })}><option value="markup_percent">Расчет через %</option><option value="manual">Установка вручную</option></select></div>
                        <div className="sp-fld"><label>% наценки</label><input type="number" className="sp-inp" value={invoiceDraft.markup_percent} onChange={(e) => setInvoiceDraft({ ...invoiceDraft, markup_percent: e.target.value })} disabled={invoiceDraft.retail_price_mode !== "markup_percent"} /></div>
                    </div>
                </div>
                <div className="sp-save-bar">
                    <span className="note">Строки товаров добавляются после создания накладной, в её карточке.</span>
                    <button type="button" className="sp-btn sp-btn-primary" onClick={saveInvoice} disabled={!selectedSupplierId}>Создать накладную</button>
                </div>
            </div>
        </div>
    ));

    const filterInvoices = () => {
        const f = registryFilters;
        const q = (f.search || "").trim().toLowerCase();
        return invoices.filter((item) => {
            if (f.dateFrom && (!item.invoice_date || String(item.invoice_date) < f.dateFrom)) return false;
            if (f.dateTo && (!item.invoice_date || String(item.invoice_date) > f.dateTo)) return false;
            if (f.supplier && String(item.supplier_name || "") !== f.supplier) return false;
            if (f.org && String(item.business_organization_id || "") !== f.org) return false;
            if (f.status && String(item.status || "") !== f.status) return false;
            if (f.wmsStatus && String(item.np_wms_fact_status || "") !== f.wmsStatus) return false;
            if (q) {
                const hay = `${item.invoice_number || ""} ${item.np_tracking_number || ""}`.toLowerCase();
                if (!hay.includes(q)) return false;
            }
            return true;
        });
    };

    const openInvoiceDetail = (id) => { setSelectedInvoiceId(String(id)); setDetailOpen(true); };
    const closeInvoiceDetail = () => setDetailOpen(false);
    const uniqueSortedValues = (vals) => Array.from(new Set(vals.filter((v) => v != null && String(v).trim() !== ""))).sort();

    const renderRegistryList = () => {
        if (isOwnWarehouseMode) return renderOwnWarehouseRegistryList();
        const rows = filterInvoices();
        const supplierOptions = uniqueSortedValues(invoices.map((i) => i.supplier_name));
        const statusOptions = uniqueSortedValues(invoices.map((i) => i.status));
        const wmsOptions = uniqueSortedValues(invoices.map((i) => i.np_wms_fact_status));
        const orgOptions = uniqueSortedValues(invoices.map((i) => i.business_organization_id)).map(String);
        const setF = (patch) => setRegistryFilters((prev) => ({ ...prev, ...patch }));
        const placedCount = invoices.filter((i) => isWmsPlacedStatus(i.np_wms_fact_status)).length;
        const mismatchCount = invoices.filter((i) => i.np_wms_fact_not_equal_to_plan).length;
        const pendingCount = invoices.length - placedCount;
        return (
            <div className="suppliers-page">
                <div className="sp-card sp-toolbar">
                    <div className="sp-toolbar-head">
                        <div>
                            <h2 className="sp-h2">Реестр накладных</h2>
                            <p className="sp-hint" style={{ marginTop: "6px" }}>Показано {rows.length} из {invoices.length}</p>
                        </div>
                        <div className="sp-toolbar-actions">
                            <div className="sp-stats">
                                <span className="sp-stat">Всего <span>{invoices.length}</span></span>
                                <span className={placedCount > 0 ? "sp-stat" : "sp-stat zero"}>Размещено на WMS <span>{placedCount}</span></span>
                                <span className={pendingCount > 0 ? "sp-stat warn" : "sp-stat zero"}>Ожидают размещения <span>{pendingCount}</span></span>
                                <span className={mismatchCount > 0 ? "sp-stat warn" : "sp-stat zero"}>С расхождением <span>{mismatchCount}</span></span>
                            </div>
                            <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={() => setRegistryFilters({ dateFrom: "", dateTo: "", supplier: "", org: "", status: "", wmsStatus: "", search: "" })}>Сбросить фильтры</button>
                        </div>
                    </div>
                    <div className="sp-form-grid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))" }}>
                        <div className="sp-fld"><label>Дата с</label><input type="date" className="sp-inp" value={registryFilters.dateFrom} onChange={(e) => setF({ dateFrom: e.target.value })} /></div>
                        <div className="sp-fld"><label>Дата по</label><input type="date" className="sp-inp" value={registryFilters.dateTo} onChange={(e) => setF({ dateTo: e.target.value })} /></div>
                        <div className="sp-fld"><label>Поставщик</label><select className="sp-inp" value={registryFilters.supplier} onChange={(e) => setF({ supplier: e.target.value })}><option value="">— все —</option>{supplierOptions.map((s) => <option key={s} value={s}>{s}</option>)}</select></div>
                        <div className="sp-fld"><label>Юрлицо</label><select className="sp-inp" value={registryFilters.org} onChange={(e) => setF({ org: e.target.value })}><option value="">— все —</option>{orgOptions.map((o) => <option key={o} value={o}>{orgNameById(o)}</option>)}</select></div>
                        <div className="sp-fld"><label>Статус</label><select className="sp-inp" value={registryFilters.status} onChange={(e) => setF({ status: e.target.value })}><option value="">— все —</option>{statusOptions.map((s) => <option key={s} value={s}>{s}</option>)}</select></div>
                        <div className="sp-fld"><label>WMS статус НП</label><select className="sp-inp" value={registryFilters.wmsStatus} onChange={(e) => setF({ wmsStatus: e.target.value })}><option value="">— все —</option>{wmsOptions.map((s) => <option key={s} value={s}>{s}</option>)}</select></div>
                        <div className="sp-fld"><label>Поиск (номер / ТТН)</label><input className="sp-inp" value={registryFilters.search} placeholder="номер или трек НП" onChange={(e) => setF({ search: e.target.value })} /></div>
                    </div>
                </div>
                <div className="sp-tbl-wrap">
                    <table className="sp-tbl">
                        <thead><tr><th>ID</th><th>Поставщик</th><th>Юрлицо</th><th>Номер</th><th>Дата</th><th>Статус</th><th>WMS статус НП</th><th>Расхождение</th><th>Файлы</th><th>Строки</th></tr></thead>
                        <tbody>{rows.map((item) => (
                            <tr key={item.id} onClick={() => openInvoiceDetail(item.id)} className={String(item.id) === String(selectedInvoiceId) ? "sp-click sel" : "sp-click"}>
                                <td className="sp-strong">{item.id}</td>
                                <td>{item.supplier_name}</td>
                                <td>{item.business_organization_name || (item.business_organization_id ? orgNameById(item.business_organization_id) : "—")}</td>
                                <td>{item.invoice_number}</td>
                                <td className="sp-mini">{item.invoice_date}</td>
                                <td><span className="sp-pill">{item.status}</span></td>
                                <td><WmsFactBadge status={item.np_wms_fact_status} /></td>
                                <td>{item.np_wms_fact_not_equal_to_plan ? <span className="sp-pill warn">Да</span> : <span className="sp-mini">—</span>}</td>
                                <td>{item.attachments_count}</td>
                                <td>{item.lines_count}</td>
                            </tr>
                        ))}
                        {rows.length === 0 && <tr><td className="sp-mini" colSpan={10}>Ничего не найдено по заданным фильтрам</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderInvoiceDetail = () => (
        <div className="suppliers-page">
            <div className="sp-detail">
                <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                    <button type="button" className="sp-btn sp-btn-ghost" onClick={closeInvoiceDetail}>← Назад к реестру</button>
                    {selectedInvoice && <span className="sp-hint">Накладная #{selectedInvoice.id} · {selectedInvoice.invoice_number || "—"}</span>}
                </div>
                {selectedInvoice ? (
                    <div className="sp-card sp-panel">
                        <h3>Накладная #{selectedInvoice.id}</h3>
                        <div className="sp-block" style={{ display: "flex", gap: "18px", flexWrap: "wrap" }}>
                            <span className="sp-hint"><strong>Поставщик:</strong> {selectedInvoice.supplier_name || selectedInvoiceSupplier?.display_name || selectedInvoiceSupplier?.name || "—"}</span>
                            <span className="sp-hint"><strong>Получатель (юрлицо):</strong> {selectedInvoice.business_organization_name || (selectedInvoice.business_organization_id ? orgNameById(selectedInvoice.business_organization_id) : "—")}</span>
                        </div>
                        <div className="sp-block" style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                            <button type="button" className="sp-btn sp-btn-primary" onClick={updateSelectedInvoice}>Сохранить</button>
                            <button type="button" className="sp-btn sp-btn-ghost" onClick={syncInvoiceIdentities}>Синхронизировать внешние коды</button>
                            <button type="button" className="sp-btn sp-btn-ghost" onClick={copySelectedInvoice}>Копия</button>
                            <button type="button" className="sp-btn sp-btn-soft-danger" onClick={deleteSelectedInvoice} disabled={invoicePosted}>Удалить</button>
                            <input type="file" multiple onChange={(e) => setFiles(Array.from(e.target.files || []))} />
                            <button type="button" className="sp-btn sp-btn-ghost" onClick={uploadFiles} disabled={!files.length}>Загрузить файлы</button>
                            {isRoslynaInvoice && <button type="button" className="sp-btn sp-btn-primary" onClick={uploadRoslynaOrderForm} disabled={invoicePosted || !files.some((file) => /\.xlsx$/i.test(file.name || ""))}>Залить бланк</button>}
                            {isSnimportInvoice && <button type="button" className="sp-btn sp-btn-primary" onClick={uploadSnimportInvoice} disabled={invoicePosted || !files.some((file) => /\.xls(x)?$/i.test(file.name || ""))}>Залить накладную SNIMPORT</button>}
                            <button type="button" className="sp-btn sp-btn-primary" onClick={parseInvoice} disabled={invoicePosted}>Распарсить файл</button>
                            {!isOwnWarehouseMode && (<>
                            {debugUi && <button type="button" className="sp-btn sp-btn-ghost" onClick={runNpApiDiscovery}>NP API refs</button>}
                            {debugUi && <button type="button" className="sp-btn sp-btn-ghost" onClick={runNpWmsCheck}>NP WMS test</button>}
                            <button type="button" className="sp-btn sp-btn-ghost" onClick={() => runStockAudit(false)}>Проверить stock</button>
                            {debugUi && <button type="button" className="sp-btn sp-btn-ghost" onClick={() => runStockAudit(true)}>Stock + WMS</button>}
                            {debugUi && <button type="button" className="sp-btn sp-btn-ghost" onClick={runNpWmsGoodsDryRun} disabled={(selectedInvoice.wms_plan_source || "created_by_us") === "external_existing"}>WMS goods dry-run</button>}
                            {debugUi && <button type="button" className="sp-btn sp-btn-ghost" onClick={runNpWmsPlanDryRun} disabled={(selectedInvoice.wms_plan_source || "created_by_us") === "external_existing"}>WMS plan dry-run</button>}
                            <button
                                type="button"
                                className="sp-btn sp-btn-primary"
                                onClick={runNpWmsSendAll}
                                disabled={npWmsSending || (selectedInvoice.wms_plan_source || "created_by_us") === "external_existing" || (missingDimensionLines.length > 0 && !allowDefaultDimensions)}
                            >
                                {npWmsSending ? "Отправка в NP WMS…" : "Отправить в NP WMS"}
                            </button>
                            <button type="button" className="sp-btn sp-btn-ghost" onClick={runNpWmsFactPoll}>Обновить WMS статус</button>
                            {debugUi && <button type="button" className="sp-btn sp-btn-soft-danger" onClick={runNpWmsFactSimulation}>Simulate placed</button>}
                            </>)}
                        </div>
                        {isOwnWarehouseMode && renderPostingPanel()}
                        <div className="sp-grid3">
                            <div className="sp-fld"><label>Номер</label><input className="sp-inp" value={selectedInvoice.invoice_number || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, invoice_number: e.target.value })} /></div>
                            <div className="sp-fld"><label>Дата</label><input type="date" className="sp-inp" value={selectedInvoice.invoice_date || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, invoice_date: e.target.value })} /></div>
                            {isOwnWarehouseMode && (
                                <div className="sp-fld"><label>Ожидаемая дата поставки</label><input type="datetime-local" className="sp-inp" value={String(selectedInvoice.expected_receipt_at || "").slice(0, 16)} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, expected_receipt_at: e.target.value || null })} /></div>
                            )}
                            {!isOwnWarehouseMode && (<>
                            <div className="sp-fld">
                                <label className="sp-switch-row"><input type="checkbox" checked={selectedInvoice.delivery_via_np === true} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, delivery_via_np: e.target.checked, np_tracking_number: e.target.checked ? (selectedInvoice.np_tracking_number || "") : "", expected_receipt_at: e.target.checked ? null : selectedInvoice.expected_receipt_at })} /> Доставка Новой Почтой</label>
                                {selectedInvoice.delivery_via_np == null && (
                                    <span className="sp-hint" style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                                        Выберите способ доставки:
                                        <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={() => setSelectedInvoice({ ...selectedInvoice, delivery_via_np: true })}>Новая Почта</button>
                                        <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={() => setSelectedInvoice({ ...selectedInvoice, delivery_via_np: false })}>Другой перевозчик / самовывоз</button>
                                    </span>
                                )}
                            </div>
                            {selectedInvoice.delivery_via_np === true ? (
                                <div className="sp-fld"><label>ТТН Новой Почты *</label><input required className="sp-inp" value={selectedInvoice.np_tracking_number || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, np_tracking_number: e.target.value })} /></div>
                            ) : selectedInvoice.delivery_via_np === false ? (
                                <div className="sp-fld"><label>Ожидаемая дата и время поставки *</label><input required type="datetime-local" className="sp-inp" value={String(selectedInvoice.expected_receipt_at || "").slice(0, 16)} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, expected_receipt_at: e.target.value || null })} /></div>
                            ) : null}
                            <div className="sp-fld">
                                <label>Склад NP</label>
                                <input className="sp-inp" value={selectedInvoice.np_dest_warehouse || ""} placeholder={runtimeConfig.np_wms_default_dest_warehouse || "NP_WMS_DEST_WAREHOUSE"} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, np_dest_warehouse: e.target.value })} />
                                <span className="sp-hint" style={{ fontWeight: 400 }}>По умолчанию из env — заполняйте только для редкого override.</span>
                            </div>
                            <div className="sp-fld">
                                <label>Юрлицо (контур)</label>
                                <select className="sp-inp" value={selectedInvoice.business_organization_id || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, business_organization_id: e.target.value ? Number(e.target.value) : null })}>
                                    <option value="">— по умолчанию —</option>
                                    {businessOrganizations.map((org) => <option key={org.id} value={org.id}>{org.short_name || org.full_name || `#${org.id}`}</option>)}
                                </select>
                            </div>
                            <div className="sp-fld"><label>WMS режим</label><select className="sp-inp" value={selectedInvoice.wms_send_mode || "manual"} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, wms_send_mode: e.target.value })}><option value="manual">Ручная отправка</option><option value="auto">Авто после сохранения</option></select></div>
                            <div className="sp-fld"><label>План приема</label><select className="sp-inp" value={selectedInvoice.wms_plan_source || "created_by_us"} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, wms_plan_source: e.target.value })}><option value="created_by_us">Создать в NP из этой накладной</option><option value="external_existing">Уже создан вне UI</option></select></div>
                            {(selectedInvoice.wms_plan_source || "created_by_us") === "external_existing" && (
                                <div className="sp-fld"><label>Номер плана в NP</label><input className="sp-inp" value={selectedInvoice.external_np_plan_ref || ""} placeholder="ExternalNumber; GUID только если он известен" onChange={(e) => setSelectedInvoice({ ...selectedInvoice, external_np_plan_ref: e.target.value })} /></div>
                            )}
                            {(selectedInvoice.wms_plan_source || "created_by_us") === "external_existing" && (
                                <div className="sp-fld"><label>SalesDrive invoice id</label><input className="sp-inp" value={selectedInvoice.external_salesdrive_invoice_id || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, external_salesdrive_invoice_id: e.target.value })} /></div>
                            )}
                            </>)}
                            {isOwnWarehouseMode ? (
                                <div className="sp-fld"><label>Статус</label><input className="sp-inp" value={selectedInvoice.status || ""} disabled readOnly /></div>
                            ) : (
                            <div className="sp-fld"><label>Статус</label><input className="sp-inp" value={selectedInvoice.status || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, status: e.target.value })} /></div>
                            )}
                            <div className="sp-fld"><label>НДС</label><select className="sp-inp" value={selectedInvoice.vat_included ? "with_vat" : "without_vat"} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, vat_included: e.target.value === "with_vat" })}><option value="with_vat">С НДС</option><option value="without_vat">Без НДС</option></select></div>
                            {selectedInvoice.vat_included && (
                                <div className="sp-fld"><label>Ставка НДС, %</label><input type="number" className="sp-inp" value={selectedInvoice.default_vat_rate ?? ""} placeholder="20 или 7" onChange={(e) => setSelectedInvoice({ ...selectedInvoice, default_vat_rate: e.target.value })} /></div>
                            )}
                            <div className="sp-fld"><label>Розничная цена</label><select className="sp-inp" value={selectedInvoice.retail_price_mode || "markup_percent"} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, retail_price_mode: e.target.value })}><option value="markup_percent">Расчет через %</option><option value="manual">Установка вручную</option></select></div>
                            <div className="sp-fld"><label>% наценки</label><input type="number" className="sp-inp" value={selectedInvoice.markup_percent || ""} onChange={(e) => setSelectedInvoice({ ...selectedInvoice, markup_percent: e.target.value })} disabled={(selectedInvoice.retail_price_mode || "markup_percent") !== "markup_percent"} /></div>
                        </div>
                        {!isOwnWarehouseMode && (
                        <div className="sp-block" style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                            <span className="sp-hint">Планов создано: {(selectedInvoice.np_wms_plans || []).length}</span>
                            <span className="sp-hint">WMS статус НП:</span>
                            <WmsFactBadge status={selectedInvoice.np_wms_fact_status} />
                            <span className="sp-hint">Факт: {selectedInvoice.np_wms_fact_number || "-"}</span>
                            <span className="sp-hint">Processed: {selectedInvoice.np_wms_fact_processed == null ? "-" : selectedInvoice.np_wms_fact_processed ? "1" : "0"}</span>
                            <span className="sp-hint" style={selectedInvoice.np_wms_fact_not_equal_to_plan ? { color: "var(--sp-warn)", fontWeight: 800 } : undefined}>
                                Расхождение: {selectedInvoice.np_wms_fact_not_equal_to_plan ? "да" : "нет"}
                            </span>
                            <span className="sp-hint">Poll: {selectedInvoice.np_wms_last_poll_at ? new Date(selectedInvoice.np_wms_last_poll_at).toLocaleString() : "-"}</span>
                        </div>
                        )}
                        {!isOwnWarehouseMode && (selectedInvoice.np_wms_plans || []).length > 0 && (
                            <div className="sp-block">
                                <strong>История планов NP WMS</strong>
                                <div className="sp-table-wrap" style={{ marginTop: "8px" }}>
                                    <table className="sp-table">
                                        <thead><tr><th>ID</th><th>ExternalNumber</th><th>GUID</th><th>Статус</th><th>Отправлен</th><th>Ошибка</th></tr></thead>
                                        <tbody>{selectedInvoice.np_wms_plans.map((plan) => (
                                            <tr key={plan.id}>
                                                <td>{plan.id}</td><td>{plan.external_number}</td><td style={{ fontFamily: "monospace", fontSize: "12px" }}>{plan.guid || "—"}</td><td>{plan.status}</td>
                                                <td>{plan.sent_at ? new Date(plan.sent_at).toLocaleString() : "—"}</td><td>{plan.last_error || "—"}</td>
                                            </tr>
                                        ))}</tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                        {debugUi && npWmsCheck && (
                            <div className="sp-block">
                                <strong>NP WMS test contour</strong>
                                <div style={{ display: "grid", gap: "4px", marginTop: "8px" }}>
                                    <span className="sp-hint">Endpoint: {npWmsCheck.endpoint}</span>
                                    <span className="sp-hint">Organization: {npWmsCheck.organization}</span>
                                    <span className="sp-hint">Auth mode: {npWmsCheck.auth_mode || "basic"} / access key: {npWmsCheck.access_key_configured ? "set" : "not set"}</span>
                                    <span className="sp-hint">Default warehouse: {npWmsCheck.default_dest_warehouse || "not configured"}</span>
                                    <span className="sp-hint">WSDL: {npWmsCheck.wsdl_ok ? "ok" : "failed"} / operations: {(npWmsCheck.operations || []).slice(0, 6).join(", ")}</span>
                                    {npWmsCheck.error && <span className="sp-msg err">{npWmsCheck.error}</span>}
                                </div>
                            </div>
                        )}
                        {debugUi && npApiDiscovery && (
                            <div className="sp-block">
                                <strong>NP API refs discovery</strong>
                                <div style={{ display: "grid", gap: "8px", marginTop: "8px" }}>
                                    <span className="sp-hint">API: {npApiDiscovery.api_base_url}</span>
                                    <span className="sp-hint">Отправителей: {npApiDiscovery.senders_count || 0}</span>
                                    {(npApiDiscovery.senders || []).slice(0, 5).map((sender) => (
                                        <div key={sender.ref || sender.description} className="sp-card" style={{ display: "grid", gap: "2px", padding: "8px" }}>
                                            <strong style={{ fontSize: "13px" }}>{sender.description || sender.full_name || sender.ref}</strong>
                                            <span className="sp-hint">SenderRef: {sender.ref || "-"}</span>
                                            <span className="sp-hint">EDRPOU: {sender.edrpou || "-"} / city: {sender.city_ref || "-"}</span>
                                            <span className="sp-hint">Contacts: {(npApiDiscovery.contacts_by_sender?.[sender.ref] || []).length}; addresses: {(npApiDiscovery.addresses_by_sender?.[sender.ref] || []).length}</span>
                                        </div>
                                    ))}
                                    {npApiDiscovery.suggested_env && (
                                        <pre className="sp-card" style={{ margin: 0, whiteSpace: "pre-wrap", fontSize: "12px", padding: "8px" }}>
                                            {Object.entries(npApiDiscovery.suggested_env).map(([key, value]) => `${key}=${value || ""}`).join("\n")}
                                        </pre>
                                    )}
                                    {(npApiDiscovery.warnings || []).map((item) => <span key={item} className="sp-msg err">{item}</span>)}
                                </div>
                            </div>
                        )}
                        {selectedInvoice.attachments?.length > 0 && (
                            <div className="sp-block">
                                {selectedInvoice.attachments.map((item) => <p key={item.id} className="sp-mini">{item.original_filename} / {item.file_role} / {item.parser_status}</p>)}
                            </div>
                        )}
                        {stockAudit && (
                            <div className="sp-block">
                                <strong>Проверка stock по накладной</strong>
                                <p className="sp-hint">SKU: {(stockAudit.skus || []).join(", ") || "нет mapped SKU"}</p>
                                <p className="sp-hint">Cost snapshots: {(stockAudit.cost_snapshots || []).length}; local stock snapshots: {(stockAudit.local_stock_snapshots || []).length}; WMS remains: {(stockAudit.wms_remains || []).length}</p>
                                {stockAudit.wms_error && <p className="sp-msg err">{stockAudit.wms_error}</p>}
                                {(stockAudit.cost_snapshots || []).length > 0 && (
                                    <div className="sp-tbl-wrap" style={{ marginTop: "10px" }}>
                                        <table className="sp-tbl">
                                            <thead><tr><th>SKU</th><th>Себестоимость с НДС</th><th>НДС %</th><th>РРЦ (последний приход)</th><th>Invoice line</th></tr></thead>
                                            <tbody>{stockAudit.cost_snapshots.map((item) => (
                                                <tr key={item.sku}><td>{item.sku}</td><td>{item.last_cost_price}</td><td>{item.last_vat_rate ?? ""}</td><td>{item.last_retail_price ?? ""}{item.last_retail_price_source ? ` (${item.last_retail_price_source})` : ""}</td><td>{item.last_invoice_line_id}</td></tr>
                                            ))}</tbody>
                                        </table>
                                    </div>
                                )}
                                {(stockAudit.local_stock_snapshots || []).length > 0 && (
                                    <div className="sp-tbl-wrap" style={{ marginTop: "10px" }}>
                                        <table className="sp-tbl">
                                            <thead><tr><th>SKU</th><th>Склад</th><th>Качество</th><th>Доступно</th><th>Карантин</th><th>Брак</th></tr></thead>
                                            <tbody>{stockAudit.local_stock_snapshots.map((item) => (
                                                <tr key={`${item.sku}-${item.warehouse}-${item.quality}`}><td>{item.sku}</td><td>{item.warehouse}</td><td>{item.quality}</td><td>{item.available_qty}</td><td>{item.quarantine_qty}</td><td>{item.defect_qty}</td></tr>
                                            ))}</tbody>
                                        </table>
                                    </div>
                                )}
                                {(stockAudit.wms_remains || []).length > 0 && (
                                    <div className="sp-tbl-wrap" style={{ marginTop: "10px" }}>
                                        <table className="sp-tbl">
                                            <thead><tr><th>WMS SKU</th><th>Склад</th><th>Качество</th><th>Qty</th><th>Batch</th></tr></thead>
                                            <tbody>{stockAudit.wms_remains.map((item, index) => (
                                                <tr key={`${item.sku}-${item.warehouse}-${item.quality}-${item.batch_id}-${index}`}><td>{item.sku}</td><td>{item.warehouse}</td><td>{item.quality}</td><td>{item.qty}</td><td>{item.batch_id}</td></tr>
                                            ))}</tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                        {debugUi && npWmsGoodsDryRun && (
                            <div className="sp-block">
                                <strong>WMS goods dry-run</strong>
                                <p className="sp-hint">Plan #{npWmsGoodsDryRun.plan_id}; Organization: {npWmsGoodsDryRun.organization}; SKU: {npWmsGoodsDryRun.lines_count}</p>
                                <div className="sp-tbl-wrap" style={{ marginTop: "10px" }}>
                                    <table className="sp-tbl">
                                        <thead><tr><th>SKU</th><th>Название</th><th>ШК</th><th>Вес</th><th>Габариты</th><th>Источник</th><th>Нет ВГХ</th></tr></thead>
                                        <tbody>{(npWmsGoodsDryRun.lines || []).map((item) => (
                                            <tr key={item.sku}>
                                                <td>{item.sku}</td>
                                                <td>{item.goods_unit_name}</td>
                                                <td>{item.barcode}</td>
                                                <td>{item.weight}</td>
                                                <td>{[item.length, item.width, item.height].filter(Boolean).join(" x ")}</td>
                                                <td>{item.dimensions_source}</td>
                                                <td>{item.missing_dimensions ? "да" : "нет"}</td>
                                            </tr>
                                        ))}</tbody>
                                    </table>
                                </div>
                                <textarea readOnly className="sp-inp" style={{ minHeight: "120px", fontFamily: "monospace", fontSize: "12px", marginTop: "10px" }} value={npWmsGoodsDryRun.soap_envelope_xml || ""} />
                            </div>
                        )}
                        {debugUi && npWmsPlanDryRun && (
                            <div className="sp-block">
                                <strong>WMS plan dry-run</strong>
                                <p className="sp-hint">Plan #{npWmsPlanDryRun.plan_id} / {npWmsPlanDryRun.external_number} / GUID {npWmsPlanDryRun.guid}</p>
                                <p className="sp-hint">Organization: {npWmsPlanDryRun.organization}; warehouse: {npWmsPlanDryRun.dest_warehouse || "не задан"}; строк: {npWmsPlanDryRun.lines_count}</p>
                                <div className="sp-tbl-wrap" style={{ marginTop: "10px" }}>
                                    <table className="sp-tbl">
                                        <thead><tr><th>SKU</th><th>Название</th><th>Qty</th><th>Price</th><th>Barcode</th><th>Batch</th></tr></thead>
                                        <tbody>{(npWmsPlanDryRun.lines || []).map((item) => (
                                            <tr key={`${item.invoice_line_id}-${item.sku}`}><td>{item.sku}</td><td>{item.good_name}</td><td>{item.qty}</td><td>{item.price}</td><td>{item.barcode}</td><td>{item.batch_id}</td></tr>
                                        ))}</tbody>
                                    </table>
                                </div>
                                <textarea readOnly className="sp-inp" style={{ minHeight: "120px", fontFamily: "monospace", fontSize: "12px", marginTop: "10px" }} value={npWmsPlanDryRun.soap_envelope_xml || ""} />
                            </div>
                        )}
                        {npWmsSendResult && (
                            <div className="sp-block">
                                <strong>{npWmsSendResult.operation}</strong>
                                <p className="sp-hint">Status: {npWmsSendResult.status}; HTTP: {npWmsSendResult.status_code}</p>
                                {(npWmsSendResult.errors || []).length > 0 && <p className="sp-msg err">{npWmsSendResult.errors.join("; ")}</p>}
                                {(npWmsSendResult.info || []).length > 0 && <p className="sp-hint">{npWmsSendResult.info.join("; ")}</p>}
                                <textarea readOnly className="sp-inp" style={{ minHeight: "90px", fontFamily: "monospace", fontSize: "12px", marginTop: "8px" }} value={npWmsSendResult.response_xml || ""} />
                            </div>
                        )}
                        {npWmsFactResult && (
                            <div className="sp-block">
                                <strong>WMS fact polling</strong>
                                <p className="sp-hint">Facts: {npWmsFactResult.facts_count}; stock events: {npWmsFactResult.stock_events_created}</p>
                                {(npWmsFactResult.errors || []).length > 0 && <p className="sp-msg err">{npWmsFactResult.errors.join("; ")}</p>}
                                <textarea readOnly className="sp-inp" style={{ minHeight: "120px", fontFamily: "monospace", fontSize: "12px", marginTop: "8px" }} value={JSON.stringify(npWmsFactResult.facts || [], null, 2)} />
                            </div>
                        )}
                        {!invoicePosted && (
                        <div className="sp-block">
                            <button
                                type="button"
                                className="sp-btn sp-btn-ghost"
                                style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%", textAlign: "left" }}
                                onClick={() => setManualLineOpen((prev) => !prev)}
                                aria-expanded={manualLineOpen}
                            >
                                <span>Ручное добавление позиции</span>
                                <span>{manualLineOpen ? "Свернуть" : "Раскрыть"}</span>
                            </button>
                            {manualLineOpen && (
                                <div style={{ display: "grid", gap: "10px", marginTop: "10px" }}>
                                    <div className="sp-form-grid" style={{ gridTemplateColumns: "minmax(220px, 1fr) auto" }}>
                                        <div className="sp-fld">
                                            <label>Поиск по ШК, названию, SKU или коду поставщика</label>
                                            <input
                                                className="sp-inp"
                                                value={productSearch}
                                                onChange={(event) => setProductSearch(event.target.value)}
                                                onKeyDown={(event) => {
                                                    if (event.key === "Enter") runProductSearch();
                                                }}
                                            />
                                        </div>
                                        <button type="button" className="sp-btn sp-btn-ghost" style={{ alignSelf: "end" }} onClick={runProductSearch}>Найти</button>
                                    </div>
                                    {productResults.length > 0 && (
                                        <div style={{ display: "grid", gap: "6px", maxHeight: "180px", overflow: "auto" }}>
                                            {productResults.map((item) => (
                                                <button
                                                    type="button"
                                                    key={`${item.sku}-${item.match_source}`}
                                                    className="sp-btn sp-btn-ghost"
                                                    style={{ textAlign: "left", padding: "8px 10px" }}
                                                    onClick={() => selectProductForManualLine(item)}
                                                >
                                                    {item.sku} / {item.barcode || "без ШК"} / {item.name_ua || item.name_ru || ""} / {item.match_source} / ВГХ: {dimensionBadge(item)}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                    {manualLineDraft.sku && (
                                        <div className="sp-card" style={{ padding: "10px", display: "grid", gap: "8px" }}>
                                            <strong style={{ fontSize: "13px" }}>Весогабариты карточки товара</strong>
                                            <div className="sp-grid3" style={{ gridTemplateColumns: "repeat(4, minmax(100px, 1fr))" }}>
                                                <div className="sp-fld"><label>Вес, г</label><input type="number" className="sp-inp" value={manualLineDraft.weight_g} onChange={(e) => setManualLineDraft({ ...manualLineDraft, weight_g: e.target.value })} /></div>
                                                <div className="sp-fld"><label>Длина, мм</label><input type="number" className="sp-inp" value={manualLineDraft.length_mm} onChange={(e) => setManualLineDraft({ ...manualLineDraft, length_mm: e.target.value })} /></div>
                                                <div className="sp-fld"><label>Ширина, мм</label><input type="number" className="sp-inp" value={manualLineDraft.width_mm} onChange={(e) => setManualLineDraft({ ...manualLineDraft, width_mm: e.target.value })} /></div>
                                                <div className="sp-fld"><label>Высота, мм</label><input type="number" className="sp-inp" value={manualLineDraft.height_mm} onChange={(e) => setManualLineDraft({ ...manualLineDraft, height_mm: e.target.value })} /></div>
                                            </div>
                                            <p className="sp-hint">Перед добавлением позиции эти параметры сохраняются в master_catalog и затем уходят в NP WMS.</p>
                                        </div>
                                    )}
                                    <div className="sp-grid3" style={{ gridTemplateColumns: "repeat(5, minmax(120px, 1fr))" }}>
                                        <div className="sp-fld"><label>SKU</label><input className="sp-inp" value={manualLineDraft.sku} onChange={(e) => setManualLineDraft({ ...manualLineDraft, sku: e.target.value })} /></div>
                                        <div className="sp-fld"><label>ШК</label><input className="sp-inp" value={manualLineDraft.barcode} onChange={(e) => setManualLineDraft({ ...manualLineDraft, barcode: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Код поставщика</label><input className="sp-inp" value={manualLineDraft.supplier_product_code} onChange={(e) => setManualLineDraft({ ...manualLineDraft, supplier_product_code: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Кол-во</label><input type="number" className="sp-inp" value={manualLineDraft.qty_expected} onChange={(e) => setManualLineDraft({ ...manualLineDraft, qty_expected: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Себестоимость без НДС</label><input type="number" className="sp-inp" value={manualLineDraft.cost_price} onChange={(e) => setManualLineDraft({ ...manualLineDraft, cost_price: e.target.value })} /></div>
                                        {selectedInvoice?.vat_included && (
                                            <div className="sp-fld"><label>НДС строки, %</label><input type="number" className="sp-inp" value={manualLineDraft.vat_rate} placeholder={selectedInvoice.default_vat_rate ?? "по накладной"} onChange={(e) => setManualLineDraft({ ...manualLineDraft, vat_rate: e.target.value })} /></div>
                                        )}
                                        <div className="sp-fld"><label>Название</label><input className="sp-inp" value={manualLineDraft.supplier_product_name} onChange={(e) => setManualLineDraft({ ...manualLineDraft, supplier_product_name: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Производитель</label><input className="sp-inp" value={manualLineDraft.manufacturer} onChange={(e) => setManualLineDraft({ ...manualLineDraft, manufacturer: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Сумма</label><input type="number" className="sp-inp" value={manualLineDraft.line_total} onChange={(e) => setManualLineDraft({ ...manualLineDraft, line_total: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Розница вручную</label><input type="number" className="sp-inp" value={manualLineDraft.retail_price_manual} onChange={(e) => setManualLineDraft({ ...manualLineDraft, retail_price_manual: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Срок</label><input type="date" className="sp-inp" value={manualLineDraft.expiration_date} onChange={(e) => setManualLineDraft({ ...manualLineDraft, expiration_date: e.target.value })} /></div>
                                        <div className="sp-fld"><label>Партия</label><input className="sp-inp" value={manualLineDraft.batch_id} onChange={(e) => setManualLineDraft({ ...manualLineDraft, batch_id: e.target.value })} /></div>
                                    </div>
                                    <div><button type="button" className="sp-btn sp-btn-primary" onClick={addManualLine}>Добавить позицию</button></div>
                                </div>
                            )}
                        </div>
                        )}
                        <div className="sp-block" style={{ display: "flex", gap: "18px", alignItems: "center", flexWrap: "wrap" }}>
                            <strong style={{ fontSize: "13px" }}>Итого:</strong>
                            <span className="sp-hint">Позиций: {invoiceTotals.count}</span>
                            <span className="sp-hint">Кол-во: {Number(invoiceTotals.qty.toFixed(3))}</span>
                            <span className="sp-hint">Сумма без НДС: {Number(selectedInvoice.total_cost ?? invoiceTotals.lineTotal).toFixed(2)}</span>
                            {selectedInvoice.vat_included && <span className="sp-hint">НДС: {selectedInvoice.total_vat != null ? Number(selectedInvoice.total_vat).toFixed(2) : "—"}</span>}
                            <span className="sp-hint">Сумма с НДС: {(selectedInvoice.vat_included ? invoiceTotals.costWithVatTotal : Number(selectedInvoice.total_cost ?? invoiceTotals.lineTotal)).toFixed(2)}</span>
                            <span className="sp-hint">Розница: {invoiceTotals.retailTotal.toFixed(2)}{selectedInvoice.retail_price_mode === "markup_percent" ? " (от себестоимости с НДС)" : ""}</span>
                        </div>
                        <div className="sp-tbl-wrap" style={{ marginTop: "12px" }}>
                            <table className="sp-tbl" style={{ minWidth: selectedInvoice.vat_included ? "1580px" : "1440px" }}>
                                <thead><tr><th>#</th><th>Код</th><th>Название</th><th>ШК</th><th>Наш SKU</th><th>Mapping</th><th>Внешняя идентичность</th><th>Габариты</th><th>Производитель</th><th>Qty</th><th>Cost без НДС</th>{selectedInvoice.vat_included && (<><th>НДС %</th><th>Cost с НДС</th></>)}<th>Сумма без НДС</th><th>Розница (от с/с с НДС)</th><th>Срок</th><th>Batch</th><th>Действия</th></tr></thead>
                                <tbody>{(selectedInvoice.lines || []).map((line) => {
                                    const isEditing = Boolean(editingLineIds[line.id]);
                                    const draft = lineDrafts[line.id] || {};
                                    const effectiveVatRate = line.vat_rate ?? selectedInvoice.default_vat_rate;
                                    const renderCell = (field, fallback, options = {}) => {
                                        if (!isEditing) return fallback ?? "";
                                        return (
                                            <input
                                                type={options.type || "text"}
                                                className="sp-inp"
                                                style={{ minWidth: options.minWidth || "100px" }}
                                                value={draft[field] ?? ""}
                                                placeholder={options.placeholder}
                                                onChange={(event) => setLineDrafts((prev) => ({
                                                    ...prev,
                                                    [line.id]: { ...prev[line.id], [field]: event.target.value },
                                                }))}
                                            />
                                        );
                                    };
                                    return (
                                        <tr key={line.id}>
                                            <td>{line.line_no}</td>
                                            <td>{renderCell("supplier_product_code", line.supplier_product_code, { minWidth: "100px" })}</td>
                                            <td>{renderCell("supplier_product_name", line.supplier_product_name, { minWidth: "220px" })}</td>
                                            <td>{renderCell("barcode", line.barcode, { minWidth: "130px" })}</td>
                                            <td>{renderCell("sku", line.mapped_sku || "", { minWidth: "120px", placeholder: "SKU" })}</td>
                                            <td>
                                                <div>{line.mapping_source || (line.mapped_sku ? "auto" : "не найден")}</div>
                                                {line.mapped_product_name && <div className="sp-hint" style={{ marginTop: "4px" }}>{line.mapped_product_name}</div>}
                                            </td>
                                            <td>
                                                {(line.enterprise_identity_syncs || []).length ? (line.enterprise_identity_syncs || []).map((item) => (
                                                    <div key={item.enterprise_code} className="sp-hint" style={{ marginBottom: "4px" }}>
                                                        <strong>{item.enterprise_code}</strong>: {item.external_product_code || "—"} / {item.external_product_name || "—"} <span style={{ color: item.status === "conflict" ? "var(--sp-danger)" : undefined }}>({item.status})</span>
                                                        {item.reason && <div>{item.reason}</div>}
                                                    </div>
                                                )) : "—"}
                                            </td>
                                            <td>
                                                <strong style={{ color: line.dimensions_complete ? "var(--sp-good-text)" : "var(--sp-danger)" }}>{dimensionBadge(line)}</strong>
                                                <div className="sp-hint" style={{ marginTop: "4px" }}>{dimensionText(line)}</div>
                                            </td>
                                            <td>{renderCell("manufacturer", line.manufacturer, { minWidth: "110px" })}</td>
                                            <td>{renderCell("qty_expected", line.qty_expected, { minWidth: "80px", type: "number" })}</td>
                                            <td>{renderCell("cost_price", line.cost_price, { minWidth: "90px", type: "number" })}</td>
                                            {selectedInvoice.vat_included && (
                                                <>
                                                    <td>{isEditing ? renderCell("vat_rate", line.vat_rate ?? "", { minWidth: "70px", type: "number", placeholder: selectedInvoice.default_vat_rate ?? "" }) : (effectiveVatRate != null ? `${Number(effectiveVatRate)}%` : "—")}</td>
                                                    <td>{line.cost_price_with_vat ?? ""}</td>
                                                </>
                                            )}
                                            <td>{renderCell("line_total", line.line_total, { minWidth: "100px", type: "number" })}</td>
                                            <td>{renderCell("retail_price_manual", line.retail_price_manual || line.retail_price_preview, { minWidth: "110px", type: "number" })}</td>
                                            <td>{renderCell("expiration_date", line.expiration_date, { minWidth: "130px", type: "date" })}</td>
                                            <td>{renderCell("batch_id", line.batch_id, { minWidth: "100px" })}</td>
                                            <td style={{ whiteSpace: "nowrap" }}>
                                                {!isEditing ? (
                                                    <button
                                                        type="button"
                                                        className="sp-btn sp-btn-ghost sp-btn-sm"
                                                        disabled={invoicePosted}
                                                        title={invoicePosted ? "Накладная проведена — строки заблокированы" : undefined}
                                                        onClick={() => setEditingLineIds((prev) => ({ ...prev, [line.id]: true }))}
                                                    >
                                                        Корректировать
                                                    </button>
                                                ) : (
                                                    <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                                                        <button type="button" className="sp-btn sp-btn-primary sp-btn-sm" onClick={() => saveLine(line)}>Сохранить</button>
                                                        <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={() => cancelLineEdit(line)}>Отмена</button>
                                                        <button type="button" className="sp-btn sp-btn-soft-danger sp-btn-sm" onClick={() => removeLine(line)}>Удалить</button>
                                                    </div>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}</tbody>
                            </table>
                        </div>
                        {!isOwnWarehouseMode && (
                        <div className="sp-block">
                            <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
                                <span style={{ fontSize: "13px", fontWeight: 700, color: missingDimensionLines.length ? "var(--sp-danger)" : "var(--sp-good-text)" }}>
                                    Весогабариты: {missingDimensionLines.length ? `проблемных SKU ${missingDimensionLines.length} — без ВГХ отправка в NP WMS блокируется` : "OK"}
                                </span>
                                <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
                                    <label style={{ display: "flex", gap: "6px", alignItems: "center", fontSize: "12px" }}>
                                        <input type="checkbox" checked={allowDefaultDimensions} onChange={(e) => setAllowDefaultDimensions(e.target.checked)} />
                                        дефолт 0.1кг / 10x5x10
                                    </label>
                                    <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={runNpWmsGoodsDryRun} disabled={(selectedInvoice.wms_plan_source || "created_by_us") === "external_existing"}>Проверить</button>
                                    {missingDimensionLines.length > 0 && <button type="button" className="sp-btn sp-btn-primary sp-btn-sm" onClick={saveAllDimensionDrafts}>Сохранить все</button>}
                                </div>
                            </div>
                            {missingDimensionLines.length > 0 && (
                                <div className="sp-tbl-wrap" style={{ marginTop: "10px" }}>
                                    <table className="sp-tbl">
                                        <thead><tr><th>SKU</th><th>Название</th><th>Вес г</th><th>Длина мм</th><th>Ширина мм</th><th>Высота мм</th><th>Действия</th></tr></thead>
                                        <tbody>{missingDimensionLines.map((line) => {
                                            const sku = line.mapped_sku;
                                            const draft = dimensionDrafts[sku] || {};
                                            const setDraft = (field, value) => setDimensionDrafts((prev) => ({
                                                ...prev,
                                                [sku]: { ...(prev[sku] || {}), [field]: value },
                                            }));
                                            return (
                                                <tr key={`${line.id}-${sku}`}>
                                                    <td>{sku}</td>
                                                    <td>{line.supplier_product_name}</td>
                                                    <td><input type="number" className="sp-inp" style={{ minWidth: "90px" }} value={draft.weight_g || ""} onChange={(e) => setDraft("weight_g", e.target.value)} /></td>
                                                    <td><input type="number" className="sp-inp" style={{ minWidth: "90px" }} value={draft.length_mm || ""} onChange={(e) => setDraft("length_mm", e.target.value)} /></td>
                                                    <td><input type="number" className="sp-inp" style={{ minWidth: "90px" }} value={draft.width_mm || ""} onChange={(e) => setDraft("width_mm", e.target.value)} /></td>
                                                    <td><input type="number" className="sp-inp" style={{ minWidth: "90px" }} value={draft.height_mm || ""} onChange={(e) => setDraft("height_mm", e.target.value)} /></td>
                                                    <td><button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={() => saveDimensionDraft(sku)}>Сохранить</button></td>
                                                </tr>
                                            );
                                        })}</tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                        )}
                    </div>
                ) : (
                    <div className="sp-card sp-panel"><p className="sp-hint">Загрузка накладной…</p></div>
                )}
            </div>
        </div>
    );

    const renderInvoiceRegistry = () => (detailOpen ? renderInvoiceDetail() : renderRegistryList());

    const orgNameById = (id) => {
        const org = businessOrganizations.find((item) => String(item.id) === String(id));
        return org ? (org.short_name || org.full_name || `#${id}`) : (id ? `#${id}` : "—");
    };

    const reloadWarehouseEntities = async () => {
        try {
            setWarehouseEntities(await listFulfillmentWarehouseEntities());
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки складов юрлиц"));
        }
    };

    const handleCreateWarehouseEntity = async () => {
        setError("");
        setMessage("");
        if (!warehouseEntityDraft.warehouse || !warehouseEntityDraft.business_organization_id) {
            setError("Укажите склад и юрлицо");
            return;
        }
        try {
            await createFulfillmentWarehouseEntity({
                warehouse: warehouseEntityDraft.warehouse.trim(),
                business_organization_id: Number(warehouseEntityDraft.business_organization_id),
                is_active: Boolean(warehouseEntityDraft.is_active),
            });
            setWarehouseEntityDraft({ warehouse: "", business_organization_id: "", is_active: true });
            setMessage("Склад привязан к юрлицу");
            await reloadWarehouseEntities();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось создать привязку склада"));
        }
    };

    const handleToggleWarehouseEntity = async (entity) => {
        try {
            await updateFulfillmentWarehouseEntity(entity.id, { is_active: !entity.is_active });
            await reloadWarehouseEntities();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось обновить привязку"));
        }
    };

    const handleDeleteWarehouseEntity = async (entity) => {
        try {
            await deleteFulfillmentWarehouseEntity(entity.id);
            await reloadWarehouseEntities();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось удалить привязку"));
        }
    };

    const renderWarehouseEntities = () => (
        <section style={pageStyle}>
            <div style={panelStyle}>
                <h3 style={{ marginTop: 0 }}>Склады фулфилмента по юрлицам</h3>
                <p style={mutedStyle}>Маппинг физического WMS-склада на наше юрлицо (контур). Один склад = одно юрлицо. Используется при синхронизации остатков и автоподстановке склада в приходах.</p>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr auto auto", gap: "10px", alignItems: "end", marginTop: "12px" }}>
                    <Field label="Склад WMS"><input style={inputStyle} value={warehouseEntityDraft.warehouse} placeholder="напр. Kv-FUL_5" onChange={(e) => setWarehouseEntityDraft({ ...warehouseEntityDraft, warehouse: e.target.value })} /></Field>
                    <Field label="Юрлицо">
                        <select style={inputStyle} value={warehouseEntityDraft.business_organization_id} onChange={(e) => setWarehouseEntityDraft({ ...warehouseEntityDraft, business_organization_id: e.target.value })}>
                            <option value="">— выбрать —</option>
                            {businessOrganizations.map((org) => <option key={org.id} value={org.id}>{org.short_name || org.full_name || `#${org.id}`}</option>)}
                        </select>
                    </Field>
                    <label style={{ ...labelStyle, flexDirection: "row", alignItems: "center", gap: "6px" }}>
                        <input type="checkbox" checked={Boolean(warehouseEntityDraft.is_active)} onChange={(e) => setWarehouseEntityDraft({ ...warehouseEntityDraft, is_active: e.target.checked })} /> активен
                    </label>
                    <button type="button" style={primaryButtonStyle} onClick={handleCreateWarehouseEntity}>Добавить</button>
                </div>
            </div>
            <div style={panelStyle}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead><tr><th style={thStyle}>Склад</th><th style={thStyle}>Юрлицо</th><th style={thStyle}>Активен</th><th style={thStyle}>Действия</th></tr></thead>
                    <tbody>
                        {warehouseEntities.length === 0 && <tr><td style={tdStyle} colSpan={4}>Привязок пока нет.</td></tr>}
                        {warehouseEntities.map((entity) => (
                            <tr key={entity.id}>
                                <td style={tdStyle}><strong>{entity.warehouse}</strong></td>
                                <td style={tdStyle}>{entity.business_organization_name || orgNameById(entity.business_organization_id)}</td>
                                <td style={tdStyle}>{entity.is_active ? "да" : "нет"}</td>
                                <td style={tdStyle}>
                                    <button type="button" style={buttonStyle} onClick={() => handleToggleWarehouseEntity(entity)}>{entity.is_active ? "Деактивировать" : "Активировать"}</button>{" "}
                                    <button type="button" style={dangerButtonStyle} onClick={() => handleDeleteWarehouseEntity(entity)}>Удалить</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );

    const reloadSupplierConfigs = async () => {
        try {
            setSupplierConfigs(await listFulfillmentSupplierConfigs());
        } catch (err) {
            setError(apiErrorMessage(err, "Ошибка загрузки реестра поставщиков"));
        }
    };

    const handleSaveSupplierConfig = async (existing) => {
        setError("");
        setMessage("");
        const draft = existing || supplierConfigDraft;
        if (!draft.supplier_code) {
            setError("Укажите код поставщика");
            return;
        }
        const payload = {
            supplier_code: String(draft.supplier_code).trim().toUpperCase(),
            business_organization_id: draft.business_organization_id ? Number(draft.business_organization_id) : null,
            wms_managed: Boolean(draft.wms_managed),
            markup_percent: null,
            sellable_qualities: draft.sellable_qualities ? String(draft.sellable_qualities).trim() : null,
            offer_source_mode: draft.offer_source_mode || "legacy",
            is_active: Boolean(draft.is_active),
        };
        try {
            if (existing && existing.id) {
                await updateFulfillmentSupplierConfig(existing.id, payload);
            } else {
                await createFulfillmentSupplierConfig(payload);
                setSupplierConfigDraft({ supplier_code: "", business_organization_id: "", wms_managed: true, sellable_qualities: "", offer_source_mode: "legacy", is_active: true });
            }
            setMessage("Реестр поставщиков обновлён");
            await reloadSupplierConfigs();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось сохранить запись реестра"));
        }
    };

    const handleDeleteSupplierConfig = async (cfg) => {
        try {
            await deleteFulfillmentSupplierConfig(cfg.id);
            await reloadSupplierConfigs();
        } catch (err) {
            setError(apiErrorMessage(err, "Не удалось удалить запись реестра"));
        }
    };

    const renderSupplierConfigs = () => (
        <div className="suppliers-page">
            <div className="sp-card sp-panel">
                <h3>Реестр fulfillment-поставщиков</h3>
                <p className="lead">Связь кода поставщика (D14/D15/…) с юрлицом-депозитором. Определяет роутинг WMS-заказов и фильтр остатков/фида по юрлицу. Один физический склад может обслуживать несколько юрлиц. Наценка задаётся в «Поставщики → Наценки».</p>
                <div className="sp-grid5">
                    <div className="sp-fld">
                        <label>Код</label>
                        <input className="sp-inp" value={supplierConfigDraft.supplier_code} placeholder="D15" onChange={(e) => setSupplierConfigDraft({ ...supplierConfigDraft, supplier_code: e.target.value })} />
                    </div>
                    <div className="sp-fld">
                        <label>Юрлицо</label>
                        <select className="sp-inp" value={supplierConfigDraft.business_organization_id} onChange={(e) => setSupplierConfigDraft({ ...supplierConfigDraft, business_organization_id: e.target.value })}>
                            <option value="">— выбрать —</option>
                            {businessOrganizations.map((org) => <option key={org.id} value={org.id}>{org.short_name || org.full_name || `#${org.id}`}</option>)}
                        </select>
                    </div>
                    <div className="sp-fld">
                        <label>Качества</label>
                        <input className="sp-inp" value={supplierConfigDraft.sellable_qualities} placeholder="Кондиция" onChange={(e) => setSupplierConfigDraft({ ...supplierConfigDraft, sellable_qualities: e.target.value })} />
                    </div>
                    <div className="sp-fld"><label>Источник offer</label><select className="sp-inp" value={supplierConfigDraft.offer_source_mode || "legacy"} onChange={(e) => setSupplierConfigDraft({ ...supplierConfigDraft, offer_source_mode: e.target.value })}><option value="legacy">Legacy feed</option><option value="wholesale_fulfillment">WMS + накладные опта</option></select></div>
                    <button
                        type="button"
                        className={supplierConfigDraft.wms_managed ? "sp-check ck" : "sp-check"}
                        onClick={() => setSupplierConfigDraft({ ...supplierConfigDraft, wms_managed: !supplierConfigDraft.wms_managed })}
                    >
                        <span className="box">{supplierConfigDraft.wms_managed ? "✓" : ""}</span>
                        <span>WMS</span>
                    </button>
                    <button type="button" className="sp-btn sp-btn-primary" onClick={() => handleSaveSupplierConfig(null)}>Добавить</button>
                </div>
            </div>
            <div className="sp-tbl-wrap">
                <table className="sp-tbl">
                    <thead><tr><th>Код</th><th>SalesDrive id</th><th>Юрлицо</th><th>WMS</th><th>Качества</th><th>Активен</th><th>Действия</th></tr></thead>
                    <tbody>
                        {supplierConfigs.length === 0 && <tr><td className="sp-mini" colSpan={7}>Записей пока нет.</td></tr>}
                        {supplierConfigs.map((cfg) => (
                            <tr key={cfg.id}>
                                <td className="sp-strong">{cfg.supplier_code}</td>
                                <td>{cfg.salesdrive_supplier_id || "—"}</td>
                                <td>{cfg.business_organization_name || orgNameById(cfg.business_organization_id)}</td>
                                <td><span className={cfg.wms_managed ? "sp-badge on" : "sp-badge off"}><span className="dot" />{cfg.wms_managed ? "да" : "нет"}</span></td>
                                <td><span className="sp-pill">{cfg.sellable_qualities || "Кондиция"}</span></td>
                                <td><span className={cfg.is_active ? "sp-badge on" : "sp-badge off"}><span className="dot" />{cfg.is_active ? "да" : "нет"}</span></td>
                                <td>
                                    <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" onClick={() => handleSaveSupplierConfig({ ...cfg, is_active: !cfg.is_active })}>{cfg.is_active ? "Деактивировать" : "Активировать"}</button>{" "}
                                    <button type="button" className="sp-btn sp-btn-soft-danger sp-btn-sm" onClick={() => handleDeleteSupplierConfig(cfg)}>Удалить</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    const renderWholesaleRoutes = () => (
        <div className="suppliers-page"><div className="sp-card sp-panel">
            <h3>Оптовики фулфилмента</h3><p className="lead">Маршрут разрешает использовать последнюю накладную оптовика для WMS-остатка конкретного sender. Цены одинаковы для всех магазинов.</p>
            <div className="sp-block">
                <div className="sp-bh"><span className="ic">₴</span><h4>Базовые правила sender</h4></div>
                <p className="lead">Это fallback для всех маршрутов, где поле оставлено пустым. Правило конкретного оптовика редактируется в его карточке.</p>
                <div className="sp-grid3">
                    <div className="sp-fld"><label>Фулфилмент sender</label><select className="sp-inp" value={pricingProfileSender} onChange={(e) => selectPricingProfileSender(e.target.value)}><option value="">— выбрать —</option>{supplierConfigs.map((item) => <option key={item.id} value={item.supplier_code}>{item.supplier_code}</option>)}</select></div>
                    <div className="sp-fld"><label>Приоритет</label><input className="sp-inp" type="number" value={pricingProfileDraft.priority_override} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, priority_override: e.target.value })} /></div>
                    <div className="sp-fld"><label>Мин. наценка, %</label><input className="sp-inp" type="number" value={pricingProfileDraft.min_markup_threshold} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, min_markup_threshold: e.target.value })} /></div>
                    <label className="sp-switch-row"><input type="checkbox" checked={pricingProfileDraft.is_rrp} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, is_rrp: e.target.checked })} /><span>Использовать РРЦ</span></label>
                    <label className="sp-switch-row"><input type="checkbox" checked={pricingProfileDraft.dumping_mode} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, dumping_mode: e.target.checked })} /><span>Разрешить демпинг</span></label>
                    <label className="sp-switch-row"><input type="checkbox" checked={pricingProfileDraft.extra_markup_enabled} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, extra_markup_enabled: e.target.checked })} /><span>Доп. наценка</span></label>
                    <div className="sp-fld"><label>Доп. наценка, %</label><input className="sp-inp" type="number" value={pricingProfileDraft.extra_markup_value} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, extra_markup_value: e.target.value })} /></div>
                    <div className="sp-fld"><label>Мин. цена для наценки</label><input className="sp-inp" type="number" value={pricingProfileDraft.extra_markup_min} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, extra_markup_min: e.target.value })} /></div>
                    <div className="sp-fld"><label>Макс. цена для наценки</label><input className="sp-inp" type="number" value={pricingProfileDraft.extra_markup_max} onChange={(e) => setPricingProfileDraft({ ...pricingProfileDraft, extra_markup_max: e.target.value })} /></div>
                </div>
                <button type="button" className="sp-btn sp-btn-primary" disabled={!pricingProfileSender} onClick={savePricingProfile}>Сохранить базовые правила</button>
            </div>
            <div className="sp-grid3">
                <div className="sp-fld"><label>Фулфилмент sender</label><select className="sp-inp" value={routeDraft.fulfillment_sender_code} onChange={(e) => setRouteDraft({ ...routeDraft, fulfillment_sender_code: e.target.value })}><option value="">— выбрать —</option>{supplierConfigs.map((item) => <option key={item.id} value={item.supplier_code}>{item.supplier_code}</option>)}</select></div>
                <div className="sp-fld"><label>Оптовик</label><select className="sp-inp" value={routeDraft.wholesale_supplier_id} onChange={(e) => setRouteDraft({ ...routeDraft, wholesale_supplier_id: e.target.value })}><option value="">— выбрать —</option>{suppliers.map((item) => <option key={item.id} value={item.id}>{item.display_name || item.name}</option>)}</select></div>
                <button type="button" className="sp-btn sp-btn-primary" disabled={!routeDraft.fulfillment_sender_code || !routeDraft.wholesale_supplier_id} onClick={createWholesaleRoute}>Добавить маршрут</button>
            </div>
            <div className="sp-tbl-wrap" style={{ marginTop: "14px" }}><table className="sp-tbl"><thead><tr><th>Sender</th><th>Оптовик</th><th>Статус</th><th></th></tr></thead><tbody>{fulfillmentRoutes.map((route) => <tr key={route.id}><td>{route.fulfillment_sender_code}</td><td>{route.wholesale_supplier_name}</td><td>{route.is_active ? "Активен" : "Отключён"}</td><td><button className="sp-btn sp-btn-ghost sp-btn-sm" onClick={async () => { try { await updateFulfillmentWholesaleRoute(route.id, { is_active: !route.is_active }); await refreshFulfillmentRoutes(); } catch (err) { setError(apiErrorMessage(err, "Не удалось изменить статус маршрута")); } }}>{route.is_active ? "Отключить" : "Включить"}</button></td></tr>)}{!fulfillmentRoutes.length && <tr><td colSpan={4} className="sp-mini">Маршрутов пока нет.</td></tr>}</tbody></table></div>
        </div></div>
    );

    const renderStock = () => {
        const totals = stockSnapshots.reduce(
            (acc, item) => {
                acc.available += Number(item.available_qty || 0);
                acc.quarantine += Number(item.quarantine_qty || 0);
                acc.defect += Number(item.defect_qty || 0);
                const hasCostPrice = item.cost_price !== null && item.cost_price !== undefined && item.cost_price !== "";
                const costPrice = Number(item.cost_price);
                if (hasCostPrice && Number.isFinite(costPrice)) {
                    acc.stockValue += Number(item.available_qty || 0) * costPrice;
                    acc.withCost += 1;
                }
                return acc;
            },
            { available: 0, quarantine: 0, defect: 0, stockValue: 0, withCost: 0 },
        );
        return (
            <div className="suppliers-page">
                <div className="sp-card sp-toolbar">
                    <div className="sp-toolbar-head">
                        <div>
                            <h2 className="sp-h2">Fulfillment stock</h2>
                            <p className="sp-hint" style={{ marginTop: "6px" }}>
                                SKU: {stockSnapshots.length}; общий остаток: {totals.available + totals.quarantine + totals.defect}; доступно: {totals.available}; карантин: {totals.quarantine}; брак: {totals.defect}; сумма доступного остатка: {totals.stockValue.toLocaleString("uk-UA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} грн
                            </p>
                            {totals.withCost < stockSnapshots.length && (
                                <p className="sp-hint" style={{ marginTop: "4px" }}>
                                    Себестоимость не указана для {stockSnapshots.length - totals.withCost} строк — они не включены в сумму.
                                </p>
                            )}
                        </div>
                        <div className="sp-toolbar-actions">
                            <button type="button" className="sp-btn sp-btn-ghost" onClick={loadStockSnapshots} disabled={stockLoading}>
                                {stockLoading ? "Загрузка..." : "Обновить экран"}
                            </button>
                            <button type="button" className="sp-btn sp-btn-primary" onClick={syncStockFromNpWms} disabled={stockSyncLoading}>
                                {stockSyncLoading ? "Синхронизация..." : "Синхронизировать с NP WMS"}
                            </button>
                        </div>
                    </div>
                    <div className="sp-grid5">
                        <div className="sp-fld">
                            <label>SKU</label>
                            <input className="sp-inp" value={stockFilters.sku} onChange={(e) => setStockFilters({ ...stockFilters, sku: e.target.value })} />
                        </div>
                        <div className="sp-fld">
                            <label>Склад</label>
                            <select className="sp-inp" value={stockFilters.warehouse} onChange={(e) => setStockFilters({ ...stockFilters, warehouse: e.target.value })}>
                                <option value="">Все</option>
                                {npWarehouseOptions.map((item) => <option key={item.value} value={item.value}>{item.label}</option>)}
                            </select>
                        </div>
                        <div className="sp-fld">
                            <label>Качество</label>
                            <input className="sp-inp" value={stockFilters.quality} placeholder="Кондиция" onChange={(e) => setStockFilters({ ...stockFilters, quality: e.target.value })} />
                        </div>
                        <div className="sp-fld">
                            <label>Юрлицо</label>
                            <select className="sp-inp" value={stockFilters.business_organization_id} onChange={(e) => setStockFilters({ ...stockFilters, business_organization_id: e.target.value })}>
                                <option value="">Все</option>
                                {businessOrganizations.map((org) => <option key={org.id} value={org.id}>{org.short_name || org.full_name || `#${org.id}`}</option>)}
                            </select>
                        </div>
                        <button
                            type="button"
                            className={stockFilters.in_stock_only ? "sp-check ck" : "sp-check"}
                            onClick={() => setStockFilters({ ...stockFilters, in_stock_only: !stockFilters.in_stock_only })}
                        >
                            <span className="box">{stockFilters.in_stock_only ? "✓" : ""}</span>
                            <span>Показывать только с остатком</span>
                        </button>
                    </div>
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                        <button type="button" className="sp-btn sp-btn-primary" onClick={loadStockSnapshots}>Применить</button>
                    </div>
                    {stockSyncResult && (
                        <div className="sp-callout">
                            <span className="ic">ⓘ</span>
                            <span>
                                NP WMS sync: {stockSyncResult.status}; SKU {stockSyncResult.requested_skus || 0}; из фактов без статуса {stockSyncResult.pending_fact_seed_skus || 0}; создано {stockSyncResult.snapshots_created || 0}; WMS rows {stockSyncResult.wms_rows || 0}; updated {stockSyncResult.snapshots_updated || 0}; zeroed {stockSyncResult.snapshots_zeroed || 0}
                                {(stockSyncResult.pending_fact_discrepancy_skus || []).length ? `; расхождения прихода: ${stockSyncResult.pending_fact_discrepancy_skus.join(", ")}` : ""}
                                {(stockSyncResult.errors || []).length ? `; errors: ${stockSyncResult.errors.join("; ")}` : ""}
                            </span>
                        </div>
                    )}
                </div>
                <div className="sp-tbl-wrap">
                    <table className="sp-tbl">
                        <thead>
                            <tr>
                                <th>SKU</th>
                                <th>Название</th>
                                <th>Юрлицо</th>
                                <th>Склад</th>
                                <th>Качество</th>
                                <th>Себестоимость, грн</th>
                                <th>Доступно</th>
                                <th>Карантин</th>
                                <th>Брак</th>
                                <th>Последний факт / sync</th>
                            </tr>
                        </thead>
                        <tbody>
                            {stockSnapshots.map((item) => (
                                <tr key={`${item.sku}-${item.warehouse}-${item.quality}-${item.business_organization_id || ""}`}>
                                    <td className="sp-strong">{item.sku}</td>
                                    <td>{item.product_name || ""}</td>
                                    <td>{item.business_organization_name || (item.business_organization_id ? `#${item.business_organization_id}` : "—")}</td>
                                    <td>{item.warehouse}</td>
                                    <td><span className={qualityPillClassName(item.quality)}>{item.quality}</span></td>
                                    <td>{item.cost_price == null ? "—" : Number(item.cost_price).toLocaleString("uk-UA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                                    <td><span className={stockPillClassName(item.available_qty)}>{item.available_qty}</span></td>
                                    <td>{item.quarantine_qty}</td>
                                    <td>{item.defect_qty}</td>
                                    <td className="sp-mini">{item.updated_at ? new Date(item.updated_at).toLocaleString() : item.last_fact_at ? new Date(item.last_fact_at).toLocaleString() : ""}</td>
                                </tr>
                            ))}
                            {!stockSnapshots.length && (
                                <tr><td className="sp-mini" colSpan={10}>Остатков нет</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    };

    const renderSenderStock = () => {
        const rows = (senderStockData?.rows || []).filter((item) => Number(item.stock || 0) > 0);
        const totalStock = rows.reduce((acc, item) => acc + Number(item.stock || 0), 0);
        const selectedProduct = senderStockData?.product || senderStockSelectedProduct;
        const productBarcode = selectedProduct?.barcode || "";
        const competitorPrice = selectedProduct?.competitor_price || "";
        const distinctRetailPrices = (item) => {
            const prices = (item.store_prices || [])
                .map((price) => String(price.retail_price || "").trim())
                .filter(Boolean);
            return [...new Set(prices)];
        };
        return (
            <div className="suppliers-page">
                <div className="sp-card sp-toolbar">
                    <div className="sp-toolbar-head">
                        <div>
                            <h2 className="sp-h2">Остатки по отправителям</h2>
                            <p className="sp-hint" style={{ marginTop: "6px" }}>
                                Отправителей: {rows.length}; общий остаток: {totalStock}
                            </p>
                        </div>
                        {selectedProduct ? (
                            <div className="sp-toolbar-actions">
                                <button
                                    type="button"
                                    className="sp-btn sp-btn-ghost"
                                    onClick={() => loadSenderStockAnalogs()}
                                    disabled={senderStockAnalogsLoading}
                                >
                                    {senderStockAnalogsLoading ? "Загрузка аналогов..." : "Показать аналоги"}
                                </button>
                            </div>
                        ) : null}
                    </div>
                    <div className="sp-form-grid" style={{ gridTemplateColumns: "minmax(220px, 1fr) auto" }}>
                        <div className="sp-fld">
                            <label>Базовый код или наименование</label>
                            <input
                                className="sp-inp"
                                value={senderStockQuery}
                                onChange={(e) => setSenderStockQuery(e.target.value)}
                                onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                        runSenderStockSearch();
                                    }
                                }}
                                placeholder="SKU, barcode или часть названия"
                            />
                        </div>
                        <button type="button" className="sp-btn sp-btn-primary" onClick={runSenderStockSearch} disabled={senderStockLoading}>
                            {senderStockLoading ? "Поиск..." : "Найти"}
                        </button>
                    </div>
                    {senderStockSearchRows.length > 0 && (
                        <div className="sp-sender-list">
                            {senderStockSearchRows.map((item) => {
                                const active = selectedProduct?.sku === item.sku;
                                return (
                                    <button
                                        type="button"
                                        key={`${item.sku}-${item.match_source}`}
                                        className={active ? "sp-sender-item sel" : "sp-sender-item"}
                                        onClick={() => loadSenderStock(item)}
                                    >
                                        <span className="nm">{productTitle(item)}</span>
                                        <span className="meta">
                                            {item.barcode || ""}
                                            {item.supplier_product_id ? ` / код отправителя ${item.supplier_product_id}` : ""}
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    )}
                    {selectedProduct ? (
                        <div className="sp-callout">
                            <span className="ic">ⓘ</span>
                            <span>
                                <b>Остатки по товару:</b> {selectedProduct.name_ua || selectedProduct.name_ru || selectedProduct.sku}{" "}
                                <span className="sp-mini">{selectedProduct.sku}</span>
                                {senderStockAnalogs?.base_sku && selectedProduct.sku !== senderStockAnalogs.base_sku ? (
                                    <span className="sp-pill warn" style={{ marginLeft: "8px" }}>аналог</span>
                                ) : null}
                            </span>
                        </div>
                    ) : null}
                </div>
                <div className="sp-tbl-wrap">
                    <table className="sp-tbl">
                        <thead>
                            <tr>
                                <th>Отправитель</th>
                                <th>Код</th>
                                <th>SalesDrive ID</th>
                                <th>Код товара у отправителя</th>
                                <th>Штрихкод</th>
                                <th>Остаток</th>
                                <th>Себестоимость</th>
                                <th>РРЦ</th>
                                <th>Розница расчетная</th>
                                <th title="Цена выбранного отправителя из последней подготовки выгрузки основного аккаунта Prom. Не подтверждает цену на сайте.">Prom: к выгрузке</th>
                                <th>Цена конкурента</th>
                                <th>Обновлено</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((item) => {
                                const priceVariants = distinctRetailPrices(item);
                                const showStorePrices = priceVariants.length > 1;
                                return (
                                    <tr key={item.sender_code}>
                                        <td>{item.sender_name}</td>
                                        <td className="sp-strong">{item.sender_code}</td>
                                        <td>{item.salesdrive_supplier_id || ""}</td>
                                        <td>{item.supplier_product_code || ""}</td>
                                        <td>{productBarcode}</td>
                                        <td><span className={stockPillClassName(item.stock)}>{item.stock || 0}</span></td>
                                        <td>{item.cost_price || ""}</td>
                                        <td>{item.rrp_price || ""}</td>
                                        <td>
                                            {item.retail_price || ""}
                                            {showStorePrices ? (
                                                <div className="sp-cell-list" style={{ marginTop: "6px" }}>
                                                    {(item.store_prices || []).map((price) => (
                                                        <div key={`${item.sender_code}-${price.store_id}`} className="sp-mini">
                                                            {price.store_name || price.store_code}: {price.retail_price || ""}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : null}
                                        </td>
                                        <td>
                                            {item.prom_price || "—"}
                                            {item.prom_price != null ? (
                                            <div style={{ fontSize: 11, opacity: 0.7 }} title="Цена из последней подготовки выгрузки; цена на сайте Prom может отличаться">
                                                {item.prom_price_updated_at ? `Расчёт: ${new Date(item.prom_price_updated_at).toLocaleString()}` : "Подготовлено к выгрузке"}
                                            </div>
                                        ) : <span style={{ fontSize: 11, opacity: 0.7 }}>Нет выбранного предложения</span>}
                                        </td>
                                        <td>{competitorPrice}</td>
                                        <td className="sp-mini">{item.updated_at ? new Date(item.updated_at).toLocaleString() : ""}</td>
                                    </tr>
                                );
                            })}
                            {!rows.length && (
                                <tr><td className="sp-mini" colSpan={12}>{selectedProduct ? "Нет отправителей с положительным остатком" : "Выбери товар для просмотра остатков"}</td></tr>
                            )}
                        </tbody>
                    </table>
                </div>
                {senderStockAnalogs ? (
                    <div className="sp-card sp-panel" style={{ marginTop: "16px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px" }}>
                            <h3 style={{ fontSize: "15px", margin: 0 }}>
                                Аналоги{senderStockAnalogs.analogs?.length ? ` (${senderStockAnalogs.analogs.length})` : ""}
                            </h3>
                            <label className="sp-switch-row">
                                <input
                                    type="checkbox"
                                    checked={senderStockAnalogsInStockOnly}
                                    onChange={(event) => {
                                        const inStockOnly = event.target.checked;
                                        setSenderStockAnalogsInStockOnly(inStockOnly);
                                        loadSenderStockAnalogs(inStockOnly);
                                    }}
                                />
                                <span>Только в наличии</span>
                            </label>
                        </div>
                        <p className="lead" style={{ marginBottom: "10px" }}>
                            Клик по аналогу загрузит его остатки по отправителям выше.
                        </p>
                        {senderStockAnalogs.analogs?.length ? (
                            analogGroupDefinitions.map((group) => {
                                const groupAnalogs = senderStockAnalogs.analogs.filter((analog) => (analog.match_group || "other") === group.key);
                                if (!groupAnalogs.length) return null;
                                return <div key={group.key} style={{ marginTop: "16px" }}>
                                    <h4 style={{ fontSize: "14px", margin: "0 0 8px" }}>{group.label}</h4>
                                    <div className="sp-tbl-wrap">
                                        <table className="sp-tbl">
                                            <thead>
                                                <tr>
                                                    <th>Наименование</th>
                                                    <th>Форма</th>
                                                    <th>Кол-во</th>
                                                    <th>Суммарный остаток</th>
                                                    <th>Себестоимость (min)</th>
                                                    <th>Розница (min)</th>
                                                    <th>Цена конкурента</th>
                                                    <th>Обновлено</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                        {groupAnalogs.map((analog) => (
                                            <tr
                                                key={analog.sku}
                                                className={selectedProduct?.sku === analog.sku ? "sp-click sel" : "sp-click"}
                                                onClick={() => loadSenderStock({
                                                    sku: analog.sku,
                                                    name_ua: analog.name_ua,
                                                    name_ru: analog.name_ru,
                                                    barcode: analog.barcode,
                                                })}
                                            >
                                                <td>
                                                    <span className="sp-strong">{analog.name_ua || analog.name_ru || analog.sku}</span>{" "}
                                                    <span className="sp-mini">{analog.sku}</span>
                                                </td>
                                                <td>{analog.form || ""}</td>
                                                <td>{analog.quantity || ""}</td>
                                                <td>
                                                    <span className={stockPillClassName(analog.total_stock)}>{analog.total_stock || 0}</span>
                                                    {analog.senders_with_stock ? (
                                                        <span className="sp-mini" style={{ marginLeft: "6px" }}>
                                                            {analog.senders_with_stock} отпр.
                                                        </span>
                                                    ) : null}
                                                </td>
                                                <td>{analog.min_cost_price || ""}</td>
                                                <td>{analog.min_retail_price || ""}</td>
                                                <td>{analog.competitor_price || ""}</td>
                                                <td className="sp-mini">{analog.updated_at ? new Date(analog.updated_at).toLocaleString() : ""}</td>
                                            </tr>
                                        ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>;
                            })
                        ) : (
                            <p className="sp-mini">Аналоги не найдены</p>
                        )}
                    </div>
                ) : null}
            </div>
        );
    };

    if (mode === "stocks") {
        return (
            <main style={embedded ? pageStyle : { padding: "24px", maxWidth: "1500px", margin: "0 auto", ...pageStyle }}>
                <div className="suppliers-page">
                    <div className="sp-card" style={{ padding: "14px 14px 0" }}>
                        <div className="sp-tabbar">
                            {visibleTabs.map((tab) => (
                                <button
                                    key={tab.key}
                                    type="button"
                                    className={activeTab === tab.key ? "sp-tab active" : "sp-tab"}
                                    onClick={() => setActiveTab(tab.key)}
                                >
                                    {tab.label}
                                    {tab.key === "supplier_configs" ? <span className="count">{supplierConfigs.length}</span> : null}
                                </button>
                            ))}
                            <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" style={{ marginLeft: "auto", alignSelf: "center" }} onClick={loadBase}>Обновить</button>
                        </div>
                    </div>
                    {error && <div className="sp-msg err">{error}</div>}
                    {message && <div className="sp-msg ok">{message}</div>}
                    {activeTab === "stock" && renderStock()}
                    {activeTab === "supplier_configs" && renderSupplierConfigs()}
                    {activeTab === "wholesale_routes" && renderWholesaleRoutes()}
                    {activeTab === "sender_stock" && renderSenderStock()}
                </div>
            </main>
        );
    }

    return (
        <main style={embedded ? pageStyle : { padding: "24px", maxWidth: "1500px", margin: "0 auto", ...pageStyle }}>
            {!embedded && <h1 style={{ margin: 0, fontSize: "24px", fontWeight: 900 }}>Fulfillment</h1>}
            {mode === "wholesale" ? (
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <button style={buttonStyle} onClick={loadBase}>Обновить</button>
                </div>
            ) : (
                <div className="suppliers-page">
                    <div className="sp-tabbar">
                        {visibleTabs.map((tab) => (
                            <button
                                key={tab.key}
                                type="button"
                                className={activeTab === tab.key ? "sp-tab active" : "sp-tab"}
                                onClick={() => { setActiveTab(tab.key); if (tab.key === "invoice_registry") setDetailOpen(false); }}
                            >
                                {tab.label}
                            </button>
                        ))}
                        <button type="button" className="sp-btn sp-btn-ghost sp-btn-sm" style={{ marginLeft: "auto" }} onClick={loadBase}>Обновить</button>
                    </div>
                </div>
            )}
            {error && <div style={errorStyle}>{error}</div>}
            {message && <div style={successStyle}>{message}</div>}
            {(mode === "wholesale" || activeTab === "wholesale") && renderWholesale()}
            {mode === "full" && activeTab === "legal" && renderLegal()}
            {activeTab === "invoice_form" && renderInvoiceForm()}
            {activeTab === "invoice_registry" && renderInvoiceRegistry()}
            {activeTab === "stock" && renderStock()}
            {activeTab === "supplier_configs" && renderSupplierConfigs()}
            {activeTab === "wholesale_routes" && renderWholesaleRoutes()}
            {activeTab === "sender_stock" && renderSenderStock()}
        </main>
    );
};

export default FulfillmentPage;
